import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getSingleCertifications,
  getSingleCertificationsResponse,
  getSingleCertificationsClear,
} from "../../../redux/certificateURL/actions";
import {
  getEventDetailsBroker,
  getEventDetailsBrokerClear,
  getEventDetailsNIIT,
  getEventDetailsNIITClear,
  getSessionNIITList,
  getSessionNIITListClear,
  getSessionBrokerList,
  getSessionBrokerListClear,
  getEnrollBrokerSession,
  getEnrollBrokerSessionClear,
  joinSession,
  joinSessionClear,
  setEnrollBrokerSessionResponse,
  eventNotification,
  checkEventNotification,
  eventNotificationClear,
  checkEventNotificationClear,
  cancelSessionData,
  cancelSessionDataClear,
  hostSessionClear,
  hostSession,
  sessionWatchURLDataClear,
  sessionWatchURLDataResponse,
  boardcastDataResponse,
  getCalendarSessionList,
  getEnrollAvailabilityClear,
  getEnrollAvailability,
} from "../../../redux/events/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  SessionKeys,
  convertTimeInHourAndMin,
  formatEndDateTime,
  formatStartDateTime,
  getPriceInfoForEntity,
  SessionPrice,
  findUpcomingSession,
  clickStreamUser,
  isSessionWithinOneHour,
  convertTimeFormat,
  getProcureInfo,
  ProductCardPriceInfo,
  getSessionType,
  formatDate,
} from "../../../utils/AppUtils";
import Loader from "../../Loader/Loader";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import Dropdown from "react-bootstrap/Dropdown";
import ErrorSectionSidebar from "../../ErrorPage/ErrorSectionSideBar";
import CartPopUpComponent from "../DetailPage/CartPopUp/CartPopUpComponent";
import SessionActionButtonComponent from "../Misc/SessionActionButton/SessionActionButtonComponent";
import ConfirmModal from "../../modal/ConfirmModal";
import { Spinner } from "react-bootstrap";
import useLogin from "../../../custom-hooks/useLogin";
import { routeList } from "../../../utils/routeList";
import { setCurrentView } from "../../../redux/assignCourse/actions";
import AssignCourseModal from "../../modal/AssignCourseModal";
import RightPanelComponent from "../DetailPage/DetailPageRightPanel/RightPanelComponent";
import { isAndroid, isIOS } from "react-device-detect";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { getActiveHeader } from "../../../redux/home/actions";
import NotFoundComponent from "../NotFound/NotFoundComponent";
import DetailLearnDiscussComponent from "../DetailPage/DetailLearnDiscuss/DetailLearnDiscussComponent";
import DetailPageDiscussComponent from "../DetailPage/DetailPageDiscuss/DetailPageDiscussComponent";
import "../../../pages/GroupWorkshopDetails.scss";
import { useTranslation } from "react-i18next";
import { updateWorkshop, updateWorkshopResponseClear } from "../../../redux/groupWorkshop/actions";
import RecurrConfirmModal from "../../modal/RecurrConfirmModal";

function WorkshopDetailComp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const { t } = useTranslation();

  const c = params.get("c");
  let eventId = "";
  let event_code = "";
  let source = "";
  let from = "";
  let lp_id = "";
  let fromCert = "";
  let type = "";
  let is_home = "";
  let providerId = "";
  let providerName = "";
  let sessionId = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    eventId = paramsReq.event_id;
    event_code = paramsReq.event_code;
    source = paramsReq.source;
    from = paramsReq.from;
    lp_id = paramsReq.lp_id;
    fromCert = paramsReq.fromCert;
    type = paramsReq.type;
    is_home = paramsReq?.is_home;
    providerId = paramsReq?.provider_id;
    providerName = paramsReq?.provider_name;
    sessionId = paramsReq?.sessionId;
  }
  // const eventId = params.get('event_id');
  // const event_code = params.get('event_code');
  // const source = params.get('source');
  const authBroker = useSelector((state) => state.auth.authBroker);
  const sessionBrokerListRes = useSelector(
    (state) => state.events.sessionListBroker
  );

  const eventDetailResBroker = useSelector(
    (state) => state.events.eventDetailBroker
  );
  const sessionCancelledData = useSelector(
    (state) => state.events.sessionCancel
  );

  const clickToCancelData = useSelector((state) => state.groupworkshop.updateWorkShop)

  const [eventDetail, setEventDetail] = useState({});
  const eventsDetailRes = useSelector(
    (state) => state.certificateURL.singleCertification
  );
  const userRole = useSelector((state) => state.user.role);
  const checkNotified = useSelector((state) => state.events.checkNotified);
  const [show, setShow] = useState(false);
  const [selectedSession, setSelectedSession] = useState("");
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSessionLoading, setIsSessionLoading] = useState();
  const [title, setTitle] = useState("");
  const [sessionListing, setSessionListing] = useState([]);
  const [upcomingSessionListing, setUpcomingSessionListing] = useState([]);
  const [pastSessionListing, setPastSessionListing] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [upcomingSessionDetail, setUpcoming] = useState({});
  const notfiyEnrolled = useSelector((state) => state.events.eventNotification);
  const [notifyMeBtn, setNotifyMeBtn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [headerProdData, setHeaderProdData] = useState({});
  const [bannerPriceInfo, setBannerPriceInfo] = useState({ isFree: true });
  const [register, setRegister] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);

  const [isShowLoader, setIsShowLoader] = useState(false);

  const joinSessionData = useSelector((state) => state.events.joinSession);
  const hostSessionInfo = useSelector((state) => state.events.hostSession);
  const { isLoggedIn } = useLogin();

  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: providerId
        ? authBroker?.payload?.user?.config?.partner_menu_text !== undefined &&
          !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
          ? authBroker?.payload?.user?.config?.partner_menu_text
          : "Partners"
        : "Learn",
      active: false,
      link: providerId ? "/our-partners" : "/learn/courses?tab=1",
      isLoading: false,
    },
    {
      name: fromCert === "true" ? "Certifications" : "Events",
      active: false,
      link:
        fromCert === "true"
          ? "/learn/certifications"
          : "/learn/group-workshops",
      isLoading: false,
    },
    { name: "-", active: false, link: "", isLoading: true },
  ]);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const enrollBrokerSession = useSelector(
    (state) => state.events.enrollBrokerSession
  );
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const addToCartRes = useSelector((state) => state.product.addToCart);

  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");

  const [clickedItem, setClickedItem] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState(
    "Would you like to unregister from the session?"
  );
  const [confirmModalRecurr, setConfirmModalRecurr] = useState(false);
  const [sessionDataForModal, setSessionDataForModal] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (source !== "broker" && isLoggedIn) {
      dispatch(
        checkEventNotification({
          module: "check-notified",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            event_id: eventId,
            origin: source === "broker" ? "broker" : "xsel",
          },
        })
      );
    }
  }, [source, isLoggedIn]);
  useEffect(() => {
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);
  useEffect(() => {
    if (!_.isEmpty(addToCartRes)) {
      setIsSessionLoading(true);
      dispatch(
        getEventDetailsBroker({
          module: "eventDetailBroker",
          postData: {
            event_id: eventId,
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            origin: source === "broker" ? source : "ecom",
            language: activeLanguage ? activeLanguage : "",
          },
        })
      );
      setIsLoading(false);
      sessionsApiCalling();
    }
  }, [addToCartRes, activeLanguage, dispatch]);

  useEffect(() => {
    setLoader(true);
    sessionsApiCalling();
  }, [dispatch, authBroker, source, register, userDetails, activeLanguage]);

  const sessionsApiCalling = () => {
    setIsLoading(true);
    if (!isLoggedIn || (!_.isEmpty(authBroker) && !_.isEmpty(userDetailRes))) {
      if (source === "broker") {
        if (!_.isEmpty(authBroker))
          dispatch(
            getSessionBrokerList({
              module: "sessionBrokerList",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                event_id: eventId,
                broker_id: authBroker?.payload?.user
                  ? authBroker?.payload?.user?.broker_id
                  : "",
                language: activeLanguage ? activeLanguage : "",
                session_id: sessionId,
                // providerId: providerId ? providerId : ''
              },
            })
          );
      } else {
        dispatch(
          getSingleCertifications({
            module: "getSingleCertifications",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              email: userDetails.email,
              event_id: event_code,
              user_id: localStorage.getItem(SessionKeys.USER_ID),
              company_id: userDetails.company_id,
            },
          })
        );
      }
    }
  };

  useEffect(() => {
    setIsSessionLoading(true);
    let reqBody = {
      event_id: eventId,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      origin: source === "broker" ? source : "ecom",
      language: activeLanguage ? activeLanguage : "",
    };
    if (from === "lp") {
      reqBody.lp_id = lp_id;
    }
    dispatch(
      getEventDetailsBroker({
        module: "eventDetailBroker",
        postData: reqBody,
      })
    );
  }, [dispatch, eventId, source]);

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(eventsDetailRes) && eventsDetailRes?.status === "success") {
      setIsLoading(false);
      let eventsListDetail = eventsDetailRes.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setSessionListing(eventsListDetail.sessionList);
        const upcomingSessionList = eventsListDetail.upcomingList;
        const pastList = eventsListDetail.pastSessionList;
        // setUpcomingSessionListing(upcomingSessionList);
        let timezoneAbbr = userDetails.timezoneAbbr;
        if (timezoneAbbr === undefined) {
          timezoneAbbr = "America/New_York";
        }
        if (!_.isEmpty(upcomingSessionList)) {
          const sessionData = upcomingSessionList[0];
          sessionData.userTimezone = userDetails.timezoneAbbr
          
          setUpcoming(sessionData);
          console.log("test---", upcomingSessionList[0]);
          let priceInfo1 = getProcureInfo(sessionData.purchased_info);

          setBannerPriceInfo(priceInfo1);

          for (let session of upcomingSessionList) {
            session.can_enroll = true;
            session.hostZoomId = authBroker?.payload?.user
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker?.payload?.user?.user_id : "";
            // session.host = session.host;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setUpcomingSessionListing(upcomingSessionList);
        } else {
          setUpcoming({});
          setBannerPriceInfo({
            isFree: true,
          });
        }
        setUpcoming(
          upcomingSessionList.length > 0 ? upcomingSessionList[0] : {}
        );
        console.log("test---1", upcomingSessionList[0]);
        //for past session list
        if (!_.isEmpty(pastList)) {
          for (let session of pastList) {
            session.can_enroll = true;
            session.hostZoomId = authBroker?.payload?.user
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker?.payload?.user?.user_id : "";
            session.host = session.display_name;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setPastSessionListing(pastList);
        } else {
          setPastSessionListing([]);
        }
        setIsFetching(false);
      } else {
        setSessionListing([]);
        setUpcomingSessionListing([]);
        setPastSessionListing([]);
        setUpcoming({});
      }
      setLoader(false);
      dispatch(getSingleCertificationsClear());
    }
  }, [eventsDetailRes]);

  useEffect(() => {
    console.log("eventdetail--", eventDetailResBroker);
    if (
      !_.isEmpty(eventDetailResBroker) &&
      eventDetailResBroker?.status === "success"
    ) {
      setIsSessionLoading(false);
      let eventsListDetail = eventDetailResBroker.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setEventDetail(eventsListDetail);
        setTitle(eventsListDetail.title);
        setIsFetching(false);
      } else {
        setEventDetail({});
        setTitle("");
        setIsFetching(false);
      }

      dispatch(getEventDetailsBrokerClear());
    }
  }, [eventDetailResBroker]);

  useEffect(() => {
    if (
      !_.isEmpty(sessionBrokerListRes) &&
      sessionBrokerListRes.status === "success"
    ) {
      setIsLoading(false);
      let eventsListDetail = sessionBrokerListRes.payload.payload;
      if (!_.isEmpty(eventsListDetail)) {
        setSessionListing(eventsListDetail.sessionList);
        const upcomingSessionList = eventsListDetail.upcomingList;
        const pastList = eventsListDetail.pastSessionList;
        // setUpcomingSessionListing(upcomingSessionList);
        const sessionData = upcomingSessionList[0]
        
        sessionData.enableEdit = localStorage.getItem(SessionKeys.USER_ID) == parseInt(sessionData.author_id)
        sessionData.userTimezone = userDetails.timezoneAbbr
        sessionData.is_kickoff = sessionData.date_time[0].is_kickoff
        setUpcoming(
          upcomingSessionList.length > 0 ? upcomingSessionList[0] : {}
        );
        console.log("test---3", upcomingSessionList[0]);
        setIsFetching(false);
        let timezoneAbbr = userDetails.timezoneAbbr;
        console.log("timezoneAbbr1: ", timezoneAbbr);
        if (timezoneAbbr === undefined) {
          timezoneAbbr = "America/New_York";
        }
        for (let session of upcomingSessionList) {
          session.can_enroll = true;
          session.hostZoomId = isLoggedIn
            ? authBroker.payload.user.zoom_id
            : "";
          session.userId = isLoggedIn ? authBroker?.payload?.user?.user_id : "";
          session.host = session.display_name;
          session.show_join = false;
          session.is_broadcast = session.delivery_mode === "virtual_broadcast";

          session.start_url = "";
          session.join_url = "";
          session.meeting_id = "";
          session.segmentId = "";
          session.timezoneAbbr = timezoneAbbr;
          if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
            for (let record of session.date_time) {
              if (record.start_date) {
                session.segmentId = record.segment_id;
                session.start_url = record.start_url ? record.start_url : "";
                session.join_url =
                  session.delivery_mode === "blended_session"
                    ? record.inperson_meeting_url
                      ? record.inperson_meeting_url
                      : ""
                    : record.join_url
                      ? record.join_url
                      : "";
                session.meeting_id = record.meeting_id;

                session.is_host = record.is_host;
                session.is_participant = record.is_participant;
              }
            }
            // console.log(session)
            session.date_time = _.sortBy(session.date_time, "startDateTime");
          }
        }
        setUpcomingSessionListing(upcomingSessionList);

        //for past session list
        if (!_.isEmpty(pastList)) {
          for (let session of pastList) {
            session.can_enroll = true;
            session.hostZoomId = isLoggedIn
              ? authBroker.payload.user.zoom_id
              : "";
            session.userId = isLoggedIn ? authBroker?.payload?.user?.user_id : "";
            session.host = session.display_name;
            session.show_join = false;
            session.is_broadcast =
              session.delivery_mode === "virtual_broadcast";

            session.start_url = "";
            session.join_url = "";
            session.meeting_id = "";
            session.segmentId = "";
            session.timezoneAbbr = timezoneAbbr;
            if (_.isArray(session.date_time) && !_.isEmpty(session.date_time)) {
              for (let record of session.date_time) {
                if (record.start_date) {
                  session.segmentId = record.segment_id;
                  session.start_url = record.start_url ? record.start_url : "";
                  session.join_url =
                    session.delivery_mode === "blended_session"
                      ? record.inperson_meeting_url
                        ? record.inperson_meeting_url
                        : ""
                      : record.join_url
                        ? record.join_url
                        : "";
                  session.meeting_id = record.meeting_id;

                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                }
              }
              // console.log(session)
              session.date_time = _.sortBy(session.date_time, "startDateTime");
            }
          }
          setPastSessionListing(pastList);
        } else {
          setPastSessionListing([]);
        }
      } else {
        setSessionListing([]);
        setUpcomingSessionListing([]);
        setPastSessionListing([]);
        setUpcoming({});
      }

      dispatch(getSessionBrokerListClear());
    }
  }, [sessionBrokerListRes]);

  useEffect(() => {
    // console.log("Check notified", checkNotified);
    if (checkNotified.status === "success") {
      if (checkNotified.payload.payload.is_notified) {
        setNotifyMeBtn(true);
      }
      dispatch(checkEventNotificationClear());
    }
  }, [checkNotified]);

  useEffect(() => {
    if (providerId) {
      let breadCData = [
        {
          name:
            authBroker?.payload?.user?.config?.partner_menu_text !==
              undefined &&
              !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
              ? authBroker?.payload?.user?.config?.partner_menu_text
              : "Partners",
          active: false,
          link: "/our-partners",
          isLoading: false,
        },
      ];
      let paramsReq = {
        provider_id: providerId,
        provider_name: providerName,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      if (providerName && providerId) {
        breadCData.push({
          name: providerName,
          active: false,
          link: `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        });
      }

      breadCData.push({
        name: fromCert === "true" ? "Certificate" : "Event",
        active: false,
        link: `/partner-detail/${fromCert === "true" ? "certifications" : "events"
          }/?c=${encodedUrl}`,
        isLoading: false,
      });
      breadCData.push({
        name: title,
        active: true,
        link: "",
        isLoading: false,
      });

      setBreadCrumbData(breadCData);
    } else if (!_.isEmpty(title)) {
      let breadCData = [
        {
          name: is_home ? "Home" : "Learn",
          active: false,
          link: is_home ? "/home" : "/learn/courses?tab=1",
          isLoading: false,
        },
      ];
      let paramsReq = {
        provider_id: providerId,
        provider_name: providerName,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      if (providerName && providerId) {
        breadCData.push({
          name: providerName,
          active: false,
          link: `/partner-detail?c=${encodedUrl}`,
          isLoading: false,
        });
      }
      if (from === "lp" || from === "bundle") {
        breadCData.push({
          name: from === "bundle" ? "Combo & Offers" : "Action Path",
          active: false,
          link:
            from === "bundle"
              ? routeList.LEARN_COMBO_PAGE
              : routeList.LEARN_LEARNING_PATH_PAGE,
          isLoading: false,
        });
        breadCData.push({
          name: eventDetail?.parent_name,
          active: false,
          link: -1,
          isLoading: false,
        });
      }
      breadCData.push({
        name: fromCert === "true" ? "Certifications" : "Events",
        active: false,
        link: providerId
          ? fromCert === "true"
            ? `/partner-detail/certifications?c=${encodedUrl}`
            : `/partner-detail/events?c=${encodedUrl}`
          : from === "lp" || from === "bundle"
            ? -1
            : fromCert === "true"
              ? "/learn/certifications"
              : "/learn/group-workshops",
        isLoading: false,
      });
      breadCData.push({
        name: title,
        active: true,
        link: "",
        isLoading: false,
      });

      setBreadCrumbData(breadCData);
    } else {
      setTitle("");
    }
  }, [title]);

  const onNotifyMeHandler = (filterValue) => {
    console.log("check1");
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          event_id: eventId,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          origin: "xsel",
          status: "checked",
        },
      })
    );

    setNotifyMeBtn(true);
  };

  const uncheckNotifyMeHandler = () => {
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          event_id: eventId,
          origin: "xsel",
          status: "unchecked",
        },
      })
    );
    setNotifyMeBtn(false);
  };

  const singlePriceUpcoming = () => {
    console.log(bannerPriceInfo);
    if (_.isEmpty(bannerPriceInfo) || bannerPriceInfo.isFree) {
      return <></>;
    }
    return ProductCardPriceInfo(
      bannerPriceInfo.showText,
      bannerPriceInfo.textColor
    );
  };

  const renderRemindMeSection = () =>
    isLoggedIn && (
      <div className="form-check side-check-box">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="flexCheckDefault"
          checked={notifyMeBtn ? true : ""}
          onChange={(e) => {
            if (e.target.checked) {
              onNotifyMeHandler();
            } else {
              uncheckNotifyMeHandler();
            }
          }}
        />
        <div className="righ-disc-sec">
          <label
            className="form-check-label"
            htmlFor="flexCheckDefault"
            checked={notifyMeBtn ? true : ""}
            onClick={(e) => { }}
          >
            Remind me
          </label>
          <p className="sesstion-detail">
            We will send you an email reminder at
            <br />
            {isLoggedIn ? authBroker?.payload?.user?.email : ""}
          </p>
        </div>
      </div>
    );

  useEffect(() => {
    // console.log("joinSessionData", joinSessionData);
    if (!_.isEmpty(joinSessionData)) {
      setIsLoading(false);
      setIsShowLoader(false);
      if (joinSessionData.status === "success") {
        if (!_.isEmpty(joinSessionData.payload.payload)) {
          const sessionData = joinSessionData.payload.payload;
          if (sessionData.join_url) {
            window.open(sessionData.join_url, "_blank");
          } else {
            // window.scrollTo(0, 0);
            setShowInfoModalMsg(
              "Error joining session, please contact support"
            );
            setInfoModal(true);
            // setInfoModal(true);
          }
        }
      } else {
        // console.log(joinSessionData.error.message);
        // setShowInfoModalMsg(joinSessionData.error.message);
        let msg = joinSessionData.error.message;
        // setShowInfoModalMsg(
        //   msg ? msg : "Error joining session, please contact support"
        // );
      }
      window.scrollTo(0, 0);

      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(joinSessionClear());
    }
  }, [joinSessionData]);

  useEffect(() => {
    if (!_.isEmpty(hostSessionInfo)) {
      setIsLoading(false);
      setIsShowLoader(false);
      if (hostSessionInfo.status === "success") {
        if (!_.isEmpty(hostSessionInfo.payload.payload)) {
          // console.log("hostSessionInfo", hostSessionInfo.payload.payload);
          const hostData = hostSessionInfo.payload.payload.data;
          if (hostData.start_url) {
            window.open(hostData.start_url, "_blank");
          } else {
            window.scrollTo(0, 0);
            setShowInfoModalMsg("Server Error, please contact support");
            // setInfoModal(true);
          }
          // dispatch(hostSessionClear());
        } else {
          // console.log(hostSessionInfo.error.message);
          setShowInfoModalMsg(hostSessionInfo.error.message);
          // setInfoModal(true);
        }
      } else {
        setShowInfoModalMsg(hostSessionInfo.error.message);
      }
      window.scrollTo(0, 0);
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(hostSessionClear());
    }
  }, [hostSessionInfo]);

  const registerConfirm = (session) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (session?.is_recurring && session?.is_recurring_check) {
      setClickedItem(1);
      setSessionDataForModal(session);
      setShowModalMsg(
        `Registering this will enable you to auto-register for all upcoming ${session?.total_auto_reg_ssn} recurring sessions.`
      );
      setConfirmModal(true);
    } else {
      proceedToRegister(session);
    }
  };

  const proceedToRegister = (sessionData) => {
    // setIsLoading(true)
    // setRegister(true);

    setIsShowLoader(true);
    clickStreamUser("register-button-clicked", {
      event_id: eventId,
      session_id: sessionData.sessionId,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
      type: sessionData?.source,
    });
    dispatch(
      getEnrollBrokerSession({
        module: "enrollBrokerSession",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: sessionData.session_id,
          event_id: eventId,
          type: sessionData?.source,
        },
      })
    );
  };

  const cancelConfirm = (session, type = 'session') => {
    
    setClickedItem(2);
    session.type = type;
    setSessionDataForModal(session);
    setShowModalMsg(`Would you like to cancel the ${type}?`);
    setConfirmModal(true);
  };

  const cancelConfirmRecurr = (session) => {
    setClickedItem(2);
    setSessionDataForModal(session);
    setConfirmModalRecurr(true);
  };


  const cancelSession = (sessionData, isMultiple = false) => {
    clickStreamUser("cancel-session", {
      event_id: eventId,
      session_id: sessionData.session_id,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
    });

    let req = {};
    // if (userRole === "manager") {
    //   req = {
    //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     session_id: sessionData.session_id,
    //     event_id: eventId,
    //     origin: sessionData.source,
    //     status: "0"
    //   };
    //   if (isMultiple) {
    //     req.multiple_check = true;
    //   } else {
    //     req.multiple_check = false;
    //   }
    // } else {
    //   req = {
    //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     session_id: sessionData.session_id,
    //     session_title: sessionData.session_name,
    //     event_id: eventId,
    //     origin: sessionData.source,
    //     cancel_type:
    //       sessionData.cancel_type === undefined
    //         ? ""
    //         : sessionData.cancel_type,
    //   }
    // }
  
    if (sessionData.type == 'session') {
        req = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        session_id: sessionData.session_id,
        session_title: sessionData.session_name,
        event_id: eventId,
        origin: sessionData.source,
        cancel_type:
          sessionData.cancel_type === undefined
            ? ""
            : sessionData.cancel_type,
      }
    } else {
      req = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        session_id: "",
        event_id: eventId,
        origin: sessionData.source,
        status: "0"
      };
    }

    
    setIsShowLoader(true);
    if (sessionData.enableEdit) {
      dispatch(
        updateWorkshop({
          module: "clickToCancel",
          postData: req,
        })
      );
    } else {
      dispatch(
        cancelSessionData({
          module: "sessionCancel",
          postData: req,
        })
      );
    }
  };

  const proceedToPurchase = (sessionData, priceInfo1) => {
    console.log("sessiondata---", sessionData);
    if (isAndroid || isIOS) {
      try {
        let obj = {
          message: "click-on-purchase",
          productId: sessionData?.product_id,
          amount: sessionData?.purchased_info?.selling_price,
          title: sessionData?.session_name,
          provider_name: sessionData?.provider?.provider_display_name,
          provider_img: sessionData?.provider?.provider_img,
          enrolledtextAmount: sessionData?.purchased_info?.enrolled_text,
        };
        if (window.callbackHandler != undefined) {
          window.callbackHandler.postMessage(JSON.stringify(obj));
        }
        if (window.webkit != undefined) {
          if (window.webkit.messageHandlers.callbackHandler != undefined) {
            window.webkit.messageHandlers.callbackHandler.postMessage(
              JSON.stringify(obj)
            );
          }
        }
      } catch (err) {
        console.log("error in sending message");
      }
    }
    clickStreamUser("purchase-button-clicked", {
      event_id: eventId,
      session_id: sessionData.session_id,
      session_name: sessionData.session_name,
      user_id: isLoggedIn ? authBroker?.payload.user.user_id : "",
      type: "xsel",
    });
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(sessionData.provider)) {
      tags.push(sessionData.provider.provider_display_name);
      logoURL = sessionData.provider.provider_img;
    }
    tags.push("Session");

    const sessionType = getSessionType(sessionData.delivery_mode);
    if (sessionType) tags.push(sessionType);
    if (sessionData.host) {
      tags.push(sessionData.host);
    }
    let priceInfo = _.cloneDeep(priceInfo1);
    priceInfo.isAddToCart = sessionData.is_addtocart;
    setIsOpen(true);
    setHeaderProdData({
      id: sessionData.product_id,
      title: sessionData.session_name,
      logoURL: logoURL,
      logoAltText: "ED",
      bannerURL: sessionData.thumbnailURL,
      tagsArray: tags,
      description: sessionData.session_description,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: !priceInfo.isFree,
      priceInfo: priceInfo,
      cancel_request: sessionData.cancel_request,
    });
  };

  const launchSession = (session) => {
    clickStreamUser("launch-session", {
      event_id: eventId,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: isLoggedIn ? authBroker?.payload?.user?.user_id : "",
    });
    if (session.is_broadcast) {
      console.log("session_type: ", "brodcast");
      dispatch(
        boardcastDataResponse({
          eventId: eventId,
          sessionId: session.session_id,
          source: session.source,
        })
      );
      navigate("/session/broadcast/watch");
    } else {
      if (session.join_url) {
        console.log("session_type: ", "joinUrlVirtual");
        window.open(session.join_url, "_blank");
      } else {
        console.log("session_type: ", "meetingVirtual");
        setIsShowLoader(true);
        dispatch(
          joinSession({
            module: "joinZoomMeeting",
            postData: {
              user_id: isLoggedIn ? authBroker?.payload?.user?.user_id : "",
              meeting_id: session.meeting_id,
              session_id: session.session_id,
              segment_id: session.segmentId,
            },
          })
        );
      }
    }
  };

  const proceedToHost = (session) => {
    if (session.is_broadcast) {
      dispatch(
        boardcastDataResponse({
          eventId: eventId,
          sessionId: session.session_id,
          source: session.source,
        })
      );
      navigate("/session/broadcast/watch");
    } else {
      if (session.start_url) {
        window.open(session.start_url, "_blank");
      } else {
        dispatch(
          hostSession({
            module: "createZoomMeeting",
            postData: {
              user_id: session.userId,
              host_zoom_id: session.hostZoomId,
              meeting_topic: session.session_name,
              meeting_agaenda: session.session_name,
              meeting_startdate:
                moment.utc(session.startUTC).format("YYYY-MM-DD HH:mm") + ":00",
              duration: _.toNumber(session.durationValue),
              session_id: session.session_id,
              segment_id: session.segmentId,
            },
          })
        );
        setIsLoading(true);
        // setIsShowLoader(true);
      }
    }
  };

  useEffect(() => {
    console.log("sessionCalledData", sessionCancelledData);
    if (!_.isEmpty(sessionCancelledData)) {
      setIsShowLoader(false);
      // setRegister(!register);
      sessionsApiCalling();
      if (sessionCancelledData.status === "success") {
        // setRegister(true);
        // setInfoModal(true);
        // fetchSessionList({ origin: source });
        window.scrollTo(0, 0);
        if (source === "broker") {
          setShowInfoModalMsg("You have successfully declined.");
        } else {
          setShowInfoModalMsg("Halifax team will connect with you shortly.");
        }
        navigate(-1);
        let data = {
          origin: source,
        };
        // fetchSessionList(data)
      } else {
        setShowInfoModalMsg("Error declining.");

        window.scrollTo(0, 0);
      }
      setIsConfirm(false);
      setInfoModal(true);
      setIsLoading(false);

      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(cancelSessionDataClear());
    }
  }, [sessionCancelledData]);

  useEffect(() => {
    console.log("clickToCancelData", clickToCancelData);
    if (!_.isEmpty(clickToCancelData)) {
      setIsShowLoader(false);
      // setRegister(!register);
      sessionsApiCalling();
      if (clickToCancelData.status === "success") {
        // setRegister(true);
        // setInfoModal(true);
        // fetchSessionList({ origin: source });
        window.scrollTo(0, 0);
        if (source === "broker") {
          setShowInfoModalMsg("You have successfully cancelled.");
        } else {
          setShowInfoModalMsg("Halifax team will connect with you shortly.");
        }
        let data = {
          origin: source,
        };
        // fetchSessionList(data)
      } else {
        setShowInfoModalMsg("Error cancelling.");

        window.scrollTo(0, 0);
      }
      setIsConfirm(false);
      setInfoModal(true);
      setIsLoading(false);

      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
      dispatch(updateWorkshopResponseClear());
    }
  }, [clickToCancelData]);

  useEffect(() => {
    // console.log("enrolled", enrollBrokerSession);
    if (!_.isEmpty(enrollBrokerSession)) {
      setIsShowLoader(false);
      // dispatchAPICall();
      if (enrollBrokerSession?.status === "success") {
        // setRegister(!register);
        sessionsApiCalling();
      }
    }
  }, [enrollBrokerSession]);

  const JoinButtonEnable = (start_date, start_time, end_date, end_time) => {
    const startDateTimeUTC = moment.tz(
      `${start_date} ${start_time}`,
      "MM-DD-YYYY HH:mm",
      "UTC"
    );
    const endDateTimeUTC = moment.tz(
      `${end_date} ${end_time}`,
      "MM-DD-YYYY HH:mm",
      "UTC"
    );

    const startDateTimeEST = startDateTimeUTC.clone().tz("America/New_York");
    const endDateTimeEST = endDateTimeUTC.clone().tz("America/New_York");
    const currentDateTimeEST = moment().tz("America/New_York");
    const isInRange = currentDateTimeEST.isBetween(
      startDateTimeEST,
      endDateTimeEST,
      null,
      "[]"
    );
    return isInRange;
  };

  const [videoLoading, setVideoLoading] = useState(true);

  useEffect(() => {
    console.log("check--", upcomingSessionDetail);
    if (!_.isEmpty(upcomingSessionDetail?.video_details)) {
      let videoData = upcomingSessionDetail?.video_details;
      let ytID = videoData?.url
        ?.split("https://www.youtube.com/embed")[1]
        ?.split("title")[0]
        ?.replace('" ', "")
        ?.replace("/", "");
      setTimeout(() => floaded(ytID), 2000);
    }
  }, [upcomingSessionDetail]);

  const floaded = (ytID) => {
    console.log("YOUTUBE ID", ytID);
    try {
      let players = new window.YT.Player("youtube-player", {
        height: "70%",
        width: "100%",
        videoId: ytID,
        playerVars: {
          autoplay: 0,
        },
        events: {
          onReady: (e) => {
            setVideoLoading(false);
          },
          onPlayerReady: (e) => {
            console.log(e);
          },
          onStateChange: (e) => {
            console.log("State Change", e);
          },
        },
      });
      console.log(players);
    } catch (error) {
      console.log(error);
    }
  };

  const renderEditIcon = () => {
    return (
      <span className="editcio cursor-pointer clear-btn">
        {
          upcomingSessionDetail.multiple_check > 1 ?
            <Dropdown>
              <Dropdown.Toggle variant="success" id="edit-dropdown">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_1117_19356)">
                    <path
                      d="M19.4537 10.4057C19.0654 10.4057 18.7506 10.7205 18.7506 11.1089V21.4217C18.7506 22.0679 18.2249 22.5936 17.5787 22.5936H2.57821C1.93201 22.5936 1.40629 22.0679 1.40629 21.4217V6.42122C1.40629 5.77503 1.93201 5.24931 2.57821 5.24931H12.891C13.2794 5.24931 13.5942 4.93449 13.5942 4.54616C13.5942 4.15784 13.2794 3.84302 12.891 3.84302H2.57821C1.15658 3.84302 0 4.9996 0 6.42122V21.4217C0 22.8433 1.15658 23.9999 2.57821 23.9999H17.5787C19.0003 23.9999 20.1569 22.8433 20.1569 21.4217V11.1089C20.1569 10.7205 19.8421 10.4057 19.4537 10.4057Z"
                      fill="#1F3053"
                    />
                    <path
                      d="M23.5204 1.80566L22.1945 0.479757C21.5549 -0.159919 20.514 -0.159919 19.8743 0.479757L9.2674 11.0867C9.16924 11.1848 9.10235 11.3099 9.07507 11.446L8.41209 14.7607C8.36601 14.9912 8.43815 15.2295 8.60443 15.3958C8.7376 15.5289 8.917 15.6017 9.1016 15.6017C9.14749 15.6017 9.19362 15.5972 9.23946 15.5881L12.5541 14.9251C12.6903 14.8979 12.8153 14.8309 12.9135 14.7328L23.5204 4.1259C23.5204 4.1259 23.5205 4.1259 23.5205 4.12586C24.1601 3.48623 24.1601 2.44538 23.5204 1.80566ZM12.0696 13.5879L9.99797 14.0023L10.4124 11.9306L19.0456 3.29722L20.703 4.95458L12.0696 13.5879ZM22.526 3.13151L21.6974 3.96019L20.04 2.30283L20.8686 1.47419C20.96 1.38279 21.1087 1.38274 21.2001 1.47415L22.526 2.80005C22.6174 2.89141 22.6174 3.04015 22.526 3.13151Z"
                      fill="#1F3053"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1117_19356">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#" onClick={() => {
                  // alert(btoa(JSON.stringify({"workshopId":eventId,"sessionId":sessionId})))
                  navigate(`/learn/workshop/edit?e=${btoa(JSON.stringify({ "workshopId": eventId, "sessionId": sessionId }))}&r=${c}`)
                }}>Edit occurence</Dropdown.Item>
                <Dropdown.Item href="#" onClick={() => {
                  navigate(`/learn/workshop/edit?e=${btoa(JSON.stringify({ "workshopId": eventId }))}&r=${c}`)
                }}>Edit Workshop</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            :
            <button
              type="button"
              onClick={() => {
                navigate(`/learn/workshop/edit?e=${btoa(JSON.stringify({ "workshopId": eventId }))}`)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_1117_19356)">
                  <path
                    d="M19.4537 10.4057C19.0654 10.4057 18.7506 10.7205 18.7506 11.1089V21.4217C18.7506 22.0679 18.2249 22.5936 17.5787 22.5936H2.57821C1.93201 22.5936 1.40629 22.0679 1.40629 21.4217V6.42122C1.40629 5.77503 1.93201 5.24931 2.57821 5.24931H12.891C13.2794 5.24931 13.5942 4.93449 13.5942 4.54616C13.5942 4.15784 13.2794 3.84302 12.891 3.84302H2.57821C1.15658 3.84302 0 4.9996 0 6.42122V21.4217C0 22.8433 1.15658 23.9999 2.57821 23.9999H17.5787C19.0003 23.9999 20.1569 22.8433 20.1569 21.4217V11.1089C20.1569 10.7205 19.8421 10.4057 19.4537 10.4057Z"
                    fill="#1F3053"
                  />
                  <path
                    d="M23.5204 1.80566L22.1945 0.479757C21.5549 -0.159919 20.514 -0.159919 19.8743 0.479757L9.2674 11.0867C9.16924 11.1848 9.10235 11.3099 9.07507 11.446L8.41209 14.7607C8.36601 14.9912 8.43815 15.2295 8.60443 15.3958C8.7376 15.5289 8.917 15.6017 9.1016 15.6017C9.14749 15.6017 9.19362 15.5972 9.23946 15.5881L12.5541 14.9251C12.6903 14.8979 12.8153 14.8309 12.9135 14.7328L23.5204 4.1259C23.5204 4.1259 23.5205 4.1259 23.5205 4.12586C24.1601 3.48623 24.1601 2.44538 23.5204 1.80566ZM12.0696 13.5879L9.99797 14.0023L10.4124 11.9306L19.0456 3.29722L20.703 4.95458L12.0696 13.5879ZM22.526 3.13151L21.6974 3.96019L20.04 2.30283L20.8686 1.47419C20.96 1.38279 21.1087 1.38274 21.2001 1.47415L22.526 2.80005C22.6174 2.89141 22.6174 3.04015 22.526 3.13151Z"
                    fill="#1F3053"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1117_19356">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
        }
      </span>
    )
  }

  return (
    <>
      <Loader start={isShowLoader} />
      {!isSessionLoading &&
        !loader &&
        (_.isEmpty(eventDetail) || _.isEmpty(upcomingSessionDetail)) ? (
        <NotFoundComponent showMsg={true} />
      ) : (
        <section className="bannersection-sec create-work-group-detail pt-4 pb-4">
          {false && (
            <div className="bannersection bgba">
              <div className="bannerrimg">
                {isSessionLoading ? (
                  <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
                ) : (
                  <img src={eventDetail.banner} alt="banner-img" />
                )}
              </div>
              <div className="bb-sec">
                <div className="container d-flex align-items-center cont-baner">
                  <div className="button-box">
                    {isFetching ? (
                      ""
                    ) : upcomingSessionListing != null &&
                      upcomingSessionListing.length === 0 ? (
                      ""
                    ) : (
                      <>
                        <span>{singlePriceUpcoming()}</span>
                        {!_.isEmpty(bannerPriceInfo) &&
                          !bannerPriceInfo?.isFree &&
                          !bannerPriceInfo?.isPurchased && (
                            <button
                              type="button"
                              className="startcourse-btn"
                              onClick={() =>
                                proceedToPurchase(
                                  upcomingSessionDetail,
                                  bannerPriceInfo
                                )
                              }
                            >
                              {t('Purchase')}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                  stroke="#6941C6"
                                  strokeWidth="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          )}
                      </>
                    )}
                  </div>

                  {false && (
                    <div className="bannershare-btn">
                      <Dropdown className="customdropdown-btn">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M30 36.6666C28.6111 36.6666 27.4306 36.1805 26.4583 35.2083C25.4861 34.236 25 33.0555 25 31.6666C25 31.4721 25.0139 31.2708 25.0417 31.0624C25.0694 30.8541 25.1111 30.6666 25.1667 30.4999L13.4167 23.6666C12.9444 24.0833 12.4167 24.4096 11.8333 24.6458C11.25 24.8819 10.6389 24.9999 10 24.9999C8.61111 24.9999 7.43056 24.5138 6.45833 23.5416C5.48611 22.5694 5 21.3888 5 19.9999C5 18.611 5.48611 17.4305 6.45833 16.4583C7.43056 15.486 8.61111 14.9999 10 14.9999C10.6389 14.9999 11.25 15.118 11.8333 15.3541C12.4167 15.5902 12.9444 15.9166 13.4167 16.3333L25.1667 9.49992C25.1111 9.33325 25.0694 9.14575 25.0417 8.93742C25.0139 8.72908 25 8.5277 25 8.33325C25 6.94436 25.4861 5.76381 26.4583 4.79159C27.4306 3.81936 28.6111 3.33325 30 3.33325C31.3889 3.33325 32.5694 3.81936 33.5417 4.79159C34.5139 5.76381 35 6.94436 35 8.33325C35 9.72214 34.5139 10.9027 33.5417 11.8749C32.5694 12.8471 31.3889 13.3333 30 13.3333C29.3611 13.3333 28.75 13.2152 28.1667 12.9791C27.5833 12.743 27.0556 12.4166 26.5833 11.9999L14.8333 18.8333C14.8889 18.9999 14.9306 19.1874 14.9583 19.3958C14.9861 19.6041 15 19.8055 15 19.9999C15 20.1944 14.9861 20.3958 14.9583 20.6041C14.9306 20.8124 14.8889 20.9999 14.8333 21.1666L26.5833 27.9999C27.0556 27.5833 27.5833 27.2569 28.1667 27.0208C28.75 26.7846 29.3611 26.6666 30 26.6666C31.3889 26.6666 32.5694 27.1527 33.5417 28.1249C34.5139 29.0971 35 30.2777 35 31.6666C35 33.0555 34.5139 34.236 33.5417 35.2083C32.5694 36.1805 31.3889 36.6666 30 36.6666ZM30 9.99992C30.4722 9.99992 30.8681 9.8402 31.1875 9.52075C31.5069 9.20131 31.6667 8.80547 31.6667 8.33325C31.6667 7.86103 31.5069 7.4652 31.1875 7.14575C30.8681 6.82631 30.4722 6.66658 30 6.66658C29.5278 6.66658 29.1319 6.82631 28.8125 7.14575C28.4931 7.4652 28.3333 7.86103 28.3333 8.33325C28.3333 8.80547 28.4931 9.20131 28.8125 9.52075C29.1319 9.8402 29.5278 9.99992 30 9.99992ZM10 21.6666C10.4722 21.6666 10.8681 21.5069 11.1875 21.1874C11.5069 20.868 11.6667 20.4721 11.6667 19.9999C11.6667 19.5277 11.5069 19.1319 11.1875 18.8124C10.8681 18.493 10.4722 18.3333 10 18.3333C9.52778 18.3333 9.13194 18.493 8.8125 18.8124C8.49306 19.1319 8.33333 19.5277 8.33333 19.9999C8.33333 20.4721 8.49306 20.868 8.8125 21.1874C9.13194 21.5069 9.52778 21.6666 10 21.6666ZM30 33.3333C30.4722 33.3333 30.8681 33.1735 31.1875 32.8541C31.5069 32.5346 31.6667 32.1388 31.6667 31.6666C31.6667 31.1944 31.5069 30.7985 31.1875 30.4791C30.8681 30.1596 30.4722 29.9999 30 29.9999C29.5278 29.9999 29.1319 30.1596 28.8125 30.4791C28.4931 30.7985 28.3333 31.1944 28.3333 31.6666C28.3333 32.1388 28.4931 32.5346 28.8125 32.8541C29.1319 33.1735 29.5278 33.3333 30 33.3333Z"
                              fill="white"
                            />
                          </svg>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>{" "}
                            Like
                          </div>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7625 15.025 18.6375C15.0417 18.5125 15.0667 18.4 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.6458 7.1 14.7875C6.75 14.9292 6.38333 15 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.07083 7.1 9.2125C7.45 9.35417 7.76667 9.55 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.4875 15.025 5.3625C15.0083 5.2375 15 5.11667 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92917 16.9 7.7875C16.55 7.64583 16.2333 7.45 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5125 8.975 11.6375C8.99167 11.7625 9 11.8833 9 12C9 12.1167 8.99167 12.2375 8.975 12.3625C8.95833 12.4875 8.93333 12.6 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3542 16.9 16.2125C17.25 16.0708 17.6167 16 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.5208 5.90417 18.7125 5.7125C18.9042 5.52083 19 5.28333 19 5C19 4.71667 18.9042 4.47917 18.7125 4.2875C18.5208 4.09583 18.2833 4 18 4C17.7167 4 17.4792 4.09583 17.2875 4.2875C17.0958 4.47917 17 4.71667 17 5C17 5.28333 17.0958 5.52083 17.2875 5.7125C17.4792 5.90417 17.7167 6 18 6ZM6 13C6.28333 13 6.52083 12.9042 6.7125 12.7125C6.90417 12.5208 7 12.2833 7 12C7 11.7167 6.90417 11.4792 6.7125 11.2875C6.52083 11.0958 6.28333 11 6 11C5.71667 11 5.47917 11.0958 5.2875 11.2875C5.09583 11.4792 5 11.7167 5 12C5 12.2833 5.09583 12.5208 5.2875 12.7125C5.47917 12.9042 5.71667 13 6 13ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19C19 18.7167 18.9042 18.4792 18.7125 18.2875C18.5208 18.0958 18.2833 18 18 18C17.7167 18 17.4792 18.0958 17.2875 18.2875C17.0958 18.4792 17 18.7167 17 19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Share
                          </div>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M5 21V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V21L12 18L5 21ZM7 17.95L12 15.8L17 17.95V5H7V17.95Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Bookmark
                          </div>
                          <div className="list-drop">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M9 18H20V15.325H9V18ZM4 8.675H7V6H4V8.675ZM4 13.35H7V10.675H4V13.35ZM4 18H7V15.325H4V18ZM9 13.35H20V10.675H9V13.35ZM9 8.675H20V6H9V8.675ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Save to Wishlist
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="container">
            {false && <BreadCrumbComponent crumbList={breadCrumbData} />}

            <div className="row mt-3">
              <div className="col-md-12">
                <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="17"
                    viewBox="0 0 10 17"
                    fill="none"
                  >
                    <path
                      d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                      fill="black"
                    />
                  </svg>{" "}
                  {t("Back")}
                </button>
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="mentor-title-wrap mb-0 d-flex gap-3 align-items-center">
                    {isSessionLoading ? (
                      <div className="mentor-title mb-0">
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"50px"}
                        />
                      </div>
                    ) : (
                      <h3 className="mentor-title mb-0">{upcomingSessionDetail?.session_name}&nbsp;{upcomingSessionDetail?.is_kickoff 
                        ? `(Kickoff Session)`
                        : ""}</h3>
                    )}
                    {upcomingSessionDetail.enableEdit && renderEditIcon()}
                  </div>
                  {/* <button className="btn-primary active-page">{t("Publish")}</button> */}
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                {isLoading ? (
                  <ul className="learncourselistt-row mb-3">
                    <li>
                      <ShimmerScreen
                        case={"rect"}
                        width={"120px"}
                        height={"25px"}
                      />
                    </li>
                    <li>
                      <ShimmerScreen
                        case={"rect"}
                        width={"120px"}
                        height={"25px"}
                      />
                    </li>
                    <li>
                      <ShimmerScreen
                        case={"rect"}
                        width={"120px"}
                        height={"25px"}
                      />
                    </li>
                    <li>
                      <ShimmerScreen
                        case={"rect"}
                        width={"120px"}
                        height={"25px"}
                      />
                    </li>
                  </ul>
                ) : (
                  <ul className="group-info-lsting d-flex gap-3 mb-0">
                    {false && <li>
                      <span className="spanicn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3.80286 18.5374C3.74122 18.4807 3.73724 18.3846 3.79405 18.323C4.01277 18.0854 4.25942 17.8691 4.52722 17.6801C4.59571 17.6318 4.69044 17.6481 4.73877 17.7166C4.7871 17.7851 4.77074 17.8799 4.70225 17.9282C4.45199 18.1047 4.22155 18.3067 4.01731 18.5286C3.9605 18.5904 3.86446 18.5941 3.80286 18.5374Z"
                            fill="black"
                          />
                          <path
                            d="M5.16494 17.4654C5.12299 17.3929 5.14779 17.3 5.2203 17.258C5.34532 17.1858 5.46902 17.1171 5.59277 17.0497C5.66646 17.0097 5.75866 17.0369 5.79864 17.1104C5.83872 17.184 5.81158 17.2762 5.73799 17.3163C5.61644 17.3825 5.49494 17.4498 5.37227 17.5208C5.29929 17.5629 5.20666 17.5376 5.16494 17.4654Z"
                            fill="black"
                          />
                          <path
                            d="M21.2816 17.7858C21.2347 17.7162 21.1403 17.6978 21.0709 17.7447C21.0014 17.7916 20.983 17.8859 21.0299 17.9554C21.1139 18.0803 21.1838 18.1921 21.2434 18.2975C21.2847 18.3704 21.3773 18.3961 21.4503 18.3548C21.5232 18.3136 21.5489 18.2209 21.5076 18.1479C21.4441 18.0357 21.3702 17.9172 21.2816 17.7858Z"
                            fill="black"
                          />
                          <path
                            d="M22.1496 21.2249C22.2339 21.2249 22.3019 21.1562 22.3008 21.0719C22.2975 20.8171 22.2908 20.3365 22.2886 20.3237C22.2066 19.8251 22.0643 19.3347 21.8658 18.8661C21.8331 18.7888 21.7438 18.7527 21.6668 18.7856C21.5897 18.8182 21.5536 18.9073 21.5863 18.9845C21.7739 19.4275 21.9088 19.8908 21.9872 20.3619C21.9801 20.3525 21.9909 20.8269 21.9984 21.0786C22.0008 21.1604 22.0678 21.2249 22.1496 21.2249Z"
                            fill="black"
                          />
                          <path
                            d="M21.3313 20.4811C21.0727 18.9111 20.1353 17.5282 18.7572 16.6868C16.9432 15.5819 15.0237 14.8376 14.5817 14.6713V13.513C15.5506 12.6437 16.1662 11.3676 16.1966 9.94094C16.8631 9.94821 17.4083 9.40549 17.4083 8.73771C17.4083 8.27271 17.1436 7.8708 16.7575 7.67046C16.7927 7.43978 16.8364 7.21516 16.8789 6.99541C17.0634 6.06049 17.2541 5.09402 16.6543 3.84832C16.494 3.41969 16.2269 3.2036 15.8384 3.18658C15.7728 3.18297 15.7182 3.12344 15.7012 3.03846C15.4425 1.732 14.5841 0.78255 13.1478 0.214331C13.1429 0.213112 13.1381 0.210675 13.132 0.209503C11.9458 -0.109809 10.7765 0.117206 9.4567 0.922237C8.90911 1.23911 8.07136 1.44068 6.89967 1.53902C6.78797 1.5633 6.38728 1.46252 6.11531 1.88261C5.95505 2.12908 5.92589 2.45692 6.03881 2.73616C6.17601 3.07858 6.3375 3.42096 6.55725 3.75363C6.52809 3.86289 6.01697 4.93863 6.07401 6.59964L6.11531 7.77128C5.81906 7.98986 5.62598 8.34072 5.62598 8.73775C5.62598 9.40431 6.16748 9.94703 6.83409 9.94099C6.85233 10.0284 6.72483 12.0233 8.45015 13.5349V14.6713C8.01061 14.8365 6.08981 15.5808 4.27467 16.6868C2.89781 17.5282 1.95928 18.9112 1.70184 20.4811C1.69697 20.5029 1.70062 20.3512 1.6994 23.0405C1.6994 23.5311 2.09765 23.9293 2.58693 23.9293H20.4448C20.9341 23.9293 21.3323 23.5311 21.3323 23.0405C21.3325 20.3293 21.3349 20.503 21.3313 20.4811ZM16.199 7.91697C16.2937 7.94369 16.5547 7.99591 16.6446 7.95583C16.9178 8.11005 17.1048 8.40142 17.1048 8.73775C17.1048 9.23678 16.698 9.64474 16.199 9.63747V7.91697ZM6.83419 9.63742C6.32789 9.64225 5.92964 9.23186 5.92964 8.73771C5.92964 8.40864 6.10692 8.12336 6.36919 7.96549C6.53067 7.95578 6.68728 7.91692 6.83423 7.85257L6.83419 9.63742ZM7.13775 9.96278V7.67411C7.44492 7.43978 7.67198 7.08283 7.75331 6.66152L8.04712 5.12439C8.35551 5.30167 8.70886 5.46555 9.12047 5.61128C10.9903 6.25357 12.973 6.27663 15.0152 5.67803C15.0359 5.67199 15.0565 5.7108 15.0589 5.74118L15.156 6.68214C15.2058 7.16782 15.4936 7.57455 15.8955 7.79308V9.83285C15.8955 12.2745 14.0645 14.2706 11.7285 14.3787C9.22247 14.4989 7.13775 12.4919 7.13775 9.96278ZM9.87323 17.7796C9.75061 17.8779 9.5685 17.8184 9.52842 17.6666L8.84972 15.1169L11.2574 16.6662L9.87323 17.7796ZM11.7758 16.6662L14.1823 15.1157L13.5036 17.6666C13.4635 17.8184 13.2814 17.8779 13.1588 17.7796L11.7758 16.6662ZM11.516 16.4719L8.75381 14.6932V13.7789C9.58795 14.3969 10.6224 14.7357 11.7419 14.6823C12.6913 14.6386 13.5631 14.3035 14.2783 13.7619V14.6932L11.516 16.4719ZM2.58708 23.6258C2.26533 23.6258 2.00306 23.3635 2.00306 23.0405V20.5175C2.24953 19.0398 3.13467 17.7383 4.43259 16.9454C6.16158 15.8915 7.98403 15.1728 8.49881 14.9773L9.23461 17.7444C9.33173 18.1074 9.77006 18.2531 10.0639 18.0163L10.2472 17.8682L10.5884 18.4413C10.6297 18.5093 10.6478 18.5931 10.6381 18.6744L10.1015 23.6258H2.58708ZM21.029 23.0405C21.029 23.3635 20.7667 23.6258 20.445 23.6258H12.9305L12.3938 18.6744C12.3854 18.5931 12.4023 18.5093 12.4436 18.4401L12.786 17.8682L12.9693 18.0163C13.2595 18.2507 13.7002 18.111 13.7974 17.7444L14.5332 14.9773C15.0504 15.1728 16.8716 15.8928 18.5994 16.9454C19.8973 17.7383 20.7825 19.0398 21.0289 20.5175V23.0405H21.029Z"
                            fill="black"
                          />
                          <path
                            d="M5.19565 3.23462C5.16288 3.1569 5.19931 3.06826 5.27581 3.03549C5.35353 3.00273 5.44217 3.03915 5.47493 3.11565C5.57693 3.35729 5.67771 3.56734 5.7821 3.75671C5.8234 3.82956 5.79668 3.92185 5.72262 3.96193C5.65099 4.00323 5.55748 3.97651 5.51745 3.90245C5.40692 3.70449 5.30253 3.48596 5.19565 3.23462Z"
                            fill="black"
                          />
                          <path
                            d="M5.14587 2.3219C5.23236 2.33132 5.30482 2.26963 5.31429 2.18882C5.38681 1.57026 5.83109 1.01019 6.47046 0.898913C6.55306 0.88457 6.60832 0.80596 6.59393 0.723366C6.57964 0.64082 6.50159 0.585648 6.41839 0.599898C5.64692 0.734101 5.1012 1.40005 5.01275 2.15352C5.00309 2.23668 5.06257 2.3121 5.14587 2.3219Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      {!_.isEmpty(upcomingSessionDetail?.instructor) && (
                        <span>
                          {t("trainer")}
                          {upcomingSessionDetail?.instructor.length > 1
                            ? "s"
                            : ""}{" "}
                          {upcomingSessionDetail?.instructor?.length > 1
                            ? `(${upcomingSessionDetail?.instructor?.length})`
                            : ""}
                          <strong>
                            {upcomingSessionDetail?.instructor.map(
                              (item, index) => {
                                if (
                                  index ===
                                  upcomingSessionDetail?.instructor.length - 2
                                ) {
                                  return `${item?.name} & `;
                                } else if (
                                  index ===
                                  upcomingSessionDetail?.instructor.length - 1
                                ) {
                                  return `${item?.name}`;
                                } else {
                                  return `${item?.name}, `;
                                }
                              }
                            )}
                          </strong>
                        </span>
                      )}
                    </li>}
                    <li>
                      {/* <span className="spanicn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M8 7V3M16 7V3M7 11H17M5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21Z"
                            stroke="#2D2D2D"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span> */}
                      <span>
                        {t("workshopName")}:{" "}
                        <strong>
                          {title}
                        </strong>
                      </span>
                    </li>
                    <li>
                      <span className="spanicn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M8 7V3M16 7V3M7 11H17M5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21Z"
                            stroke="#2D2D2D"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        {t("startingDate")}:{" "}
                        <strong>
                          {!_.isEmpty(upcomingSessionDetail?.date_time) &&
                            formatDate(
                              upcomingSessionDetail?.date_time[0]?.start_date
                            )}
                        </strong>
                      </span>
                    </li>
                    <li>
                      <span className="spanicn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 8V12L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
                            stroke="#2D2D2D"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        {t("time")}:{" "}
                        <strong>
                          {moment
                            .tz(
                              `${upcomingSessionDetail?.date_time[0]?.start_date} ${upcomingSessionDetail?.date_time[0]?.start_time}`,
                              "MM-DD-YYYY HH:mm",
                              "UTC"
                            )
                            .tz(`${upcomingSessionDetail?.userTimezone}`)
                            .format("hh:mm A")}{" "}
                          -{" "}
                          {moment
                            .tz(
                              `${upcomingSessionDetail?.date_time[0]?.end_date} ${upcomingSessionDetail?.date_time[0]?.end_time}`,
                              "MM-DD-YYYY HH:mm",
                              "UTC"
                            )
                            .tz(`${upcomingSessionDetail?.userTimezone}`)
                            .format("hh:mm A")}{" "}
                          ({moment
                            .tz(
                              `${upcomingSessionDetail?.date_time[0]?.end_date} ${upcomingSessionDetail?.date_time[0]?.end_time}`,
                              "MM-DD-YYYY HH:mm",
                              "UTC"
                            )
                            .tz(`${upcomingSessionDetail?.userTimezone}`)
                            .format("z")})
                        </strong>
                      </span>
                    </li>
                    <li>
                      <span className="spanicn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_3080_79736)">
                            <path
                              d="M22.5885 7.35525C22.6265 7.23938 22.6473 7.11581 22.6473 6.98747V1.188C22.6473 0.532922 22.1124 0 21.455 0H14.1684C13.511 0 12.9761 0.532922 12.9761 1.188V1.60528C11.4043 1.57378 9.77048 1.89998 8.32603 2.53345C7.00359 3.11063 5.82113 3.92709 4.80825 4.95994H3.5625C3.36834 4.95994 3.21094 5.11734 3.21094 5.3115C3.21094 5.50566 3.36834 5.66306 3.5625 5.66306H8.47884C8.74856 5.66306 8.96803 5.88061 8.96803 6.14794V11.9474C8.96803 12.2147 8.74856 12.4323 8.47884 12.4323H7.80623C7.30331 12.4323 6.89414 12.8401 6.89414 13.3415V14.1604L4.73536 12.6047C4.57889 12.4919 4.39411 12.4323 4.20103 12.4323H1.19231C0.922594 12.4323 0.703125 12.2148 0.703125 11.9474V6.14798C0.703125 5.88061 0.922594 5.66311 1.19231 5.66311H1.92188C2.11603 5.66311 2.27344 5.5057 2.27344 5.31155C2.27344 5.11739 2.11603 4.95998 1.92188 4.95998H1.19231C0.534891 4.95998 0 5.49291 0 6.14798V11.9474C0 12.6025 0.534891 13.1355 1.19231 13.1355H1.60861C1.69195 16.0015 2.84695 18.6839 4.88316 20.7201C6.99825 22.8352 9.81042 24 12.8016 24C14.3568 24 15.8622 23.6872 17.2762 23.0702C18.6419 22.4743 19.8588 21.624 20.8934 20.5429C21.0276 20.4026 21.0227 20.1801 20.8824 20.0459C20.7421 19.9116 20.5196 19.9165 20.3854 20.0568C19.6129 20.864 18.7365 21.5304 17.7856 22.0452C17.3388 21.4505 16.6831 20.735 16.2448 20.0492L16.3286 19.9888C16.3646 19.9628 16.4072 19.9492 16.4518 19.9492H19.4605C20.118 19.9492 20.6528 19.4162 20.6528 18.7612V12.9617C20.6528 12.8832 20.645 12.8066 20.6303 12.7323C21.2345 12.009 21.5655 11.0871 21.5655 10.1142C21.5608 9.42239 21.3653 8.75395 21.0064 8.17547H21.4549C21.7017 8.17547 21.9312 8.10037 22.1216 7.97194C22.8916 9.45661 23.2969 11.1163 23.2969 12.8016C23.2969 14.9718 22.6403 17.0543 21.3983 18.8239C21.2867 18.9828 21.3251 19.2021 21.484 19.3136C21.5889 19.389 21.8145 19.4192 21.9737 19.2278C23.2993 17.3393 24 15.1171 24 12.8016C24 10.892 23.5124 9.01284 22.5885 7.35525ZM8.47884 4.95998H5.82516C6.65077 4.22241 7.57336 3.6293 8.56388 3.19219L8.79891 3.46336C9.19345 3.98133 9.43973 4.72491 9.35897 5.34745C9.14081 5.10952 8.82703 4.95998 8.47884 4.95998ZM16.6668 21.7701C16.8349 21.9748 16.9965 22.1719 17.1449 22.3643C15.801 22.9755 14.329 23.2969 12.8016 23.2969C8.86786 23.2969 5.43333 21.1211 3.63647 17.9101C4.13213 17.5013 4.77061 17.0045 5.2807 17.0637C5.48887 17.0879 5.67319 17.2095 5.84414 17.4357C6.27192 18.0012 6.9938 18.1114 7.49953 18.1451C8.25469 18.0984 8.92763 17.7127 9.34777 17.0908C9.45759 16.9306 9.41686 16.7118 9.25673 16.602C9.09661 16.4921 8.8778 16.533 8.76797 16.693C8.46586 17.1335 8.06686 17.3718 7.51425 17.4413C6.94031 17.3992 6.59742 17.2661 6.40495 17.0116C6.11616 16.6296 5.7652 16.4121 5.3618 16.3652C4.61719 16.2789 3.88486 16.8021 3.30703 17.2711C2.71059 16.0092 2.35852 14.6102 2.31216 13.1354H4.20098C4.24561 13.1354 4.28822 13.1491 4.32422 13.1751L6.59545 14.8118C6.7057 14.8913 6.83489 14.9317 6.96497 14.9317C7.06341 14.9317 7.16231 14.9085 7.25386 14.8617C7.46569 14.7533 7.59722 14.5384 7.59722 14.3009V13.3415C7.59722 13.2278 7.69097 13.1354 7.80619 13.1354H8.4788C9.13622 13.1354 9.67111 12.6024 9.67111 11.9474V10.447C10.0896 10.7051 10.7523 10.9342 11.2919 10.9195C11.8753 10.9195 12.4559 10.7455 12.9556 10.4023C13.6079 9.95433 14.0569 9.25514 14.1877 8.484C14.2047 8.38387 14.2196 8.28075 14.2323 8.17542H14.841C14.9562 8.17542 15.0499 8.26786 15.0499 8.38148V9.34088C15.0499 9.57839 15.1815 9.79331 15.3933 9.90173C15.572 9.98536 15.7897 10.0137 16.0516 9.85191L17.4989 8.80898C17.4429 9.35344 17.2965 9.9263 16.6297 10.5918C16.3165 10.9106 16.1367 11.3364 16.1272 11.7736H12.174C11.5165 11.7736 10.9816 12.3066 10.9816 12.9617V13.1137C10.329 13.3625 9.80639 13.9117 9.5722 14.6034C9.52116 14.7543 9.44123 15.0112 9.36698 15.2566C9.31022 15.4423 9.4147 15.6388 9.60038 15.6956C9.74194 15.7353 9.94238 15.6863 10.0394 15.4622C10.0892 15.2992 10.1575 15.0718 10.2382 14.8289C10.3736 14.4289 10.6414 14.0971 10.9817 13.8925V18.7611C10.9817 19.4161 11.5166 19.9491 12.174 19.9491H12.8466C12.9618 19.9491 13.0555 20.0415 13.0555 20.1551V21.1145C13.0555 21.352 13.1871 21.5669 13.3989 21.6753C13.4904 21.7222 13.5893 21.7453 13.6878 21.7453C13.8179 21.7453 13.9471 21.7049 14.0573 21.6255L15.674 20.4605C15.9704 20.9207 16.3231 21.3516 16.6668 21.7701ZM19.9498 18.7611C19.9498 19.0285 19.7303 19.246 19.4606 19.246H16.4519C16.2588 19.246 16.074 19.3056 15.9176 19.4184L13.7587 20.9741V20.1552C13.7587 19.6538 13.3496 19.246 12.8467 19.246H12.1741C11.9044 19.246 11.6849 19.0284 11.6849 18.7611V12.9617C11.6849 12.6944 11.9044 12.4768 12.1741 12.4768H16.5164C16.5167 12.4768 16.5171 12.4769 16.5174 12.4769C16.518 12.4769 16.5185 12.4768 16.519 12.4768H19.4607C19.7304 12.4768 19.9499 12.6944 19.9499 12.9617L19.9498 18.7611ZM20.8625 10.1166C20.8625 10.8308 20.647 11.5115 20.2505 12.0728C20.04 11.8869 19.7634 11.7737 19.4606 11.7737H16.8307C16.84 11.5198 16.9469 11.2723 17.1289 11.0871C18.119 10.099 18.1792 9.22336 18.2275 8.51981C18.2334 8.43337 18.2394 8.35036 18.2467 8.27011L18.3229 8.21517C18.359 8.1892 18.4016 8.17547 18.4462 8.17547H20.138C20.601 8.71753 20.8576 9.4027 20.8625 10.1166ZM21.455 7.47234H18.4462C18.2532 7.47234 18.0684 7.53192 17.9119 7.6447L17.7019 7.79606C17.7011 7.79662 17.7003 7.79719 17.6995 7.79775L15.7531 9.20044V8.38148C15.7531 7.88016 15.3439 7.4723 14.841 7.4723H14.1684C13.8987 7.4723 13.6793 7.25475 13.6793 6.98742V5.67188C13.6793 5.47772 13.5218 5.32031 13.3277 5.32031C13.1335 5.32031 12.9761 5.47772 12.9761 5.67188V6.98742C12.9761 7.41469 13.2037 7.78983 13.5444 7.99917C13.531 8.12545 13.5146 8.24859 13.4946 8.36648C13.3954 8.95111 13.0539 9.48187 12.5576 9.8227C11.6821 10.4389 10.5025 10.2833 9.67116 9.59527V6.41644C10.4255 5.42161 10.0481 3.8392 9.25528 2.91628C10.387 2.51034 11.7017 2.28155 12.9761 2.30836V4.03125C12.9761 4.22541 13.1335 4.38281 13.3276 4.38281C13.5218 4.38281 13.6792 4.22541 13.6792 4.03125V1.188C13.6792 0.920625 13.8987 0.703125 14.1684 0.703125H21.4549C21.7246 0.703125 21.9441 0.920672 21.9441 1.188V6.98742C21.9442 7.2548 21.7247 7.47234 21.455 7.47234Z"
                              fill="black"
                            />
                            <path
                              d="M19.9836 2.33217H18.1637V1.73437C18.1637 1.54022 18.0063 1.38281 17.8121 1.38281C17.618 1.38281 17.4605 1.54022 17.4605 1.73437V2.33217H15.6406C15.4465 2.33217 15.2891 2.48958 15.2891 2.68373C15.2891 2.87789 15.4465 3.0353 15.6406 3.0353H16.3696C16.5384 3.78347 16.8723 4.4715 17.3373 5.05669C16.9814 5.39639 16.5651 5.67802 16.1009 5.88492L15.6166 6.10078C15.4392 6.17981 15.3595 6.38766 15.4385 6.56498C15.4969 6.69586 15.6253 6.77353 15.7599 6.77353C15.8077 6.77353 15.8563 6.76373 15.9028 6.74302L16.3871 6.52716C16.9214 6.28903 17.4013 5.96573 17.8121 5.57592C18.223 5.96573 18.7028 6.28903 19.2371 6.52716L19.7215 6.74302C19.845 6.7942 20.0768 6.77986 20.1857 6.56498C20.2647 6.38766 20.185 6.17981 20.0076 6.10078L19.5233 5.88492C19.059 5.67806 18.6428 5.39639 18.287 5.05669C18.752 4.4715 19.0858 3.78347 19.2546 3.0353H19.9835C20.1777 3.0353 20.3351 2.87789 20.3351 2.68373C20.3351 2.48958 20.1778 2.33217 19.9836 2.33217ZM17.8121 4.52091C17.4827 4.08089 17.2369 3.57811 17.0933 3.0353H18.5309C18.3873 3.57811 18.1415 4.08089 17.8121 4.52091Z"
                              fill="black"
                            />
                            <path
                              d="M3.04786 11.4851C3.22955 11.5536 3.43242 11.4619 3.50091 11.2803L3.80602 10.4718H5.86594L6.17423 11.2813C6.22767 11.4216 6.36117 11.5079 6.50283 11.5079C6.54441 11.5079 6.58673 11.5004 6.62789 11.4847C6.80934 11.4157 6.90038 11.2125 6.83128 11.0311L5.24719 6.87178C5.24616 6.86911 5.24513 6.86644 5.24405 6.86377C5.17505 6.69516 5.01277 6.58613 4.83061 6.58594C4.83042 6.58594 4.83033 6.58594 4.83014 6.58594C4.64822 6.58594 4.48589 6.69464 4.41661 6.86292C4.4153 6.86611 4.41403 6.86934 4.41277 6.87262L2.84306 11.0321C2.77448 11.2137 2.86617 11.4165 3.04786 11.4851ZM4.83122 7.75509L5.59814 9.7687H4.07133L4.83122 7.75509Z"
                              fill="black"
                            />
                            <path
                              d="M18.5109 13.7344H16.8754C16.6812 13.7344 16.5238 13.8918 16.5238 14.0859C16.5238 14.2801 16.6812 14.4375 16.8754 14.4375H17.3415V15.5391H15.9431C16.0248 15.3727 16.0708 15.1858 16.0708 14.9883C16.0708 14.2969 15.5083 13.7344 14.8169 13.7344H13.8018C13.6076 13.7344 13.4502 13.8918 13.4502 14.0859C13.4502 14.2801 13.6076 14.4375 13.8018 14.4375H14.8169C15.1206 14.4375 15.3677 14.6846 15.3677 14.9883C15.3677 15.292 15.1206 15.5391 14.8169 15.5391H13.6889C13.4948 15.5391 13.3374 15.6965 13.3374 15.8906C13.3374 16.0848 13.4948 16.2422 13.6889 16.2422H14.8169C15.1206 16.2422 15.3677 16.4893 15.3677 16.793C15.3677 17.1018 15.1258 17.3438 14.8169 17.3438C14.3312 17.3438 13.7798 17.289 13.3736 16.8828C13.2363 16.7455 13.0137 16.7455 12.8764 16.8828C12.7391 17.0201 12.7391 17.2427 12.8764 17.3799C13.4676 17.9711 14.224 18.0469 14.8169 18.0469C15.5083 18.0469 16.0708 17.4844 16.0708 16.793C16.0708 16.5955 16.0248 16.4085 15.9431 16.2422H17.3415V17.6953C17.3415 17.8895 17.4989 18.0469 17.6931 18.0469C17.8873 18.0469 18.0447 17.8895 18.0447 17.6953V14.4375H18.5108C18.705 14.4375 18.8624 14.2801 18.8624 14.0859C18.8624 13.8918 18.705 13.7344 18.5109 13.7344Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_3080_79736">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span>
                        {t("language")}:{" "}
                        <strong>
                          {activeLanguage == "1" ? "English" : "French"}
                        </strong>
                      </span>
                    </li>
                  </ul>
                )}
              </div>
              <div className="col-12">
                <hr />
                <div className="discription-workfdlow">
                  {isSessionLoading ? (
                    <ShimmerScreen case="rect" width="60%" height="7rem" />
                  ) : (
                    <>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: eventDetail.description,
                        }}
                      ></p>
                      {/* <span className="readmore">Read More</span> */}
                    </>
                  )}
                </div>
                {/*  */}
                <hr />
              </div>
            </div>
            {false && (
              <div className="row">
                <div className="col-xl-12">
                  <div className="module-learn-text mt-0">
                    {isLoading ? (
                      <ul className="learncourselistt-row mb-3">
                        <li>
                          <ShimmerScreen
                            case={"rect"}
                            width={"80px"}
                            height={"25px"}
                          />
                        </li>
                        <li>
                          <ShimmerScreen
                            case={"rect"}
                            width={"80px"}
                            height={"25px"}
                          />
                        </li>
                      </ul>
                    ) : (
                      upcomingSessionListing.length > 0 && (
                        <div className="d-flex box-meta">
                          <div className="img-box-meta">
                            <img
                              src={
                                upcomingSessionDetail.provider
                                  ? upcomingSessionDetail.provider.provider_img
                                  : ""
                              }
                            />
                          </div>
                          <div className="meta-lsit">
                            <ul className="learncourselistt-row">
                              <li>
                                {" "}
                                {upcomingSessionDetail.provider
                                  ? upcomingSessionDetail.provider
                                    .provider_display_name
                                  : ""}{" "}
                              </li>
                              <li>Session</li>
                              <li>
                                {getSessionType(
                                  upcomingSessionDetail.delivery_mode
                                )}
                              </li>
                              <li>
                                {upcomingSessionDetail.host
                                  ? upcomingSessionDetail.host
                                  : ""}{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      )
                    )}

                    {isSessionLoading ? (
                      <ShimmerScreen case="rect" width="60%" height="7rem" />
                    ) : (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: eventDetail.description,
                        }}
                      ></p>
                    )}
                  </div>
                </div>
              </div>
            )}
            {false && (
              <div className="row">
                <div className="col-xl-8">
                  <div className="mb-2">
                    <DetailLearnDiscussComponent
                      id={eventId}
                      code={event_code}
                      type={"workshop"}
                      source={source}
                      showLearn={false}
                      showDiscuss={true}
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      learnData={eventDetail}
                      onLearnClick={() => { }}
                      isMobile={false}
                    />
                  </div>
                </div>
                <div className="col-xl-4">
                  {/* <div className="mb-4">
                  <RightPanelComponent
                    id={eventDetail?.event_id}
                    parentName={"event"}
                    code={eventDetail?.event_code}
                    moduleData={eventDetail}
                    type={"event"}
                    source={eventDetail?.origin}
                    isMobile={false}
                  />
                </div> */}
                  <div className="right-panel">
                    <div className="contsection">
                      {false && (
                        <Tabs
                          defaultActiveKey="upcoming-sessions"
                          transition={false}
                          id="noanim-tab-example"
                          className="mb-3"
                        >
                          <Tab
                            eventKey="upcoming-sessions"
                            title="Upcoming Sessions"
                          >
                            <div className="upcoming-content">
                              {isLoading ? (
                                <div className="mt-5">
                                  <h4>
                                    <ShimmerScreen
                                      case="rect"
                                      width="100%"
                                      height="2rem"
                                    />
                                  </h4>

                                  <div className="price-bar">
                                    <ShimmerScreen
                                      case="rect"
                                      width="100%"
                                      height="2rem"
                                    />
                                  </div>

                                  <div className="Segmentbar">
                                    <ShimmerScreen
                                      case="rect"
                                      width="100%"
                                      height="4rem"
                                    />
                                  </div>
                                </div>
                              ) : upcomingSessionListing != null &&
                                upcomingSessionListing.length === 0 ? (
                                <>
                                  <ErrorSectionSidebar />
                                  {source !== "broker" &&
                                    renderRemindMeSection()}
                                </>
                              ) : (
                                <>
                                  <div className="session-wrapper">
                                    {upcomingSessionListing.map(
                                      (item, index) => {
                                        let priceInfo1 = getProcureInfo(
                                          item.purchased_info
                                        );
                                        console.log("item--", item);
                                        const isUserRegistered = () => {
                                          return item.is_registered; // Replace with your logic
                                        };
                                        return (
                                          <div
                                            className="mt-inner-sec mt-4"
                                            key={index}
                                          >
                                            <div className="d-flex user-table-box">
                                              <div className="brokarage-icon">
                                                <img
                                                  src={
                                                    !_.isEmpty(item?.provider)
                                                      ? item?.provider
                                                        ?.provider_img
                                                      : "https://cdnstg.training.com/xsel/image/6e139227-97e8-4726-9a03-2dd339cfff53.jpg"
                                                  }
                                                />
                                              </div>
                                              <h4 className="event-sidebar-title">
                                                {item.session_name}
                                              </h4>
                                            </div>

                                            {item.date_time.map(
                                              (segment, i) => {
                                                return (
                                                  <>
                                                    <div
                                                      className="Segmentbar"
                                                      key={i}
                                                    >
                                                      <p className="sesstion-detail-head">
                                                        {segment.segment_title}
                                                      </p>
                                                      <p className="sesstion-detail">
                                                        {formatStartDateTime(
                                                          segment.start_date,
                                                          segment.start_time,
                                                          item.timezoneAbbr
                                                        )}
                                                      </p>
                                                      <p className="sesstion-detail">
                                                        {formatEndDateTime(
                                                          segment.end_date,
                                                          segment.end_time,
                                                          item.timezoneAbbr
                                                        )}
                                                      </p>

                                                      <div className="event-details">
                                                        <ul>
                                                          <li>
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="25"
                                                              height="25"
                                                              viewBox="0 0 20 20"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M15.3033 14.4701L10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701ZM10 12.5001C11.8409 12.5001 13.3333 11.0077 13.3333 9.16675C13.3333 7.3258 11.8409 5.83341 10 5.83341C8.15905 5.83341 6.66667 7.3258 6.66667 9.16675C6.66667 11.0077 8.15905 12.5001 10 12.5001ZM10 10.8334C9.0795 10.8334 8.33333 10.0872 8.33333 9.16675C8.33333 8.24627 9.0795 7.50008 10 7.50008C10.9205 7.50008 11.6667 8.24627 11.6667 9.16675C11.6667 10.0872 10.9205 10.8334 10 10.8334Z"
                                                                fill="#6941C6"
                                                              />
                                                            </svg>
                                                            <span className="text-ec">
                                                              {item.delivery_mode ===
                                                                "blended_session" ? (
                                                                <>
                                                                  {"In-Person/Virtual (" +
                                                                    item.location +
                                                                    ")"}
                                                                </>
                                                              ) : item.delivery_mode ===
                                                                "face_to_face" ? (
                                                                <>
                                                                  {"In-Person (" +
                                                                    item.location +
                                                                    ")"}
                                                                </>
                                                              ) : item.delivery_mode ===
                                                                "virtual_interactive" ||
                                                                item.delivery_mode ===
                                                                "virtual_broadcast" ? (
                                                                "Virtual"
                                                              ) : (
                                                                "Live"
                                                              )}
                                                            </span>
                                                          </li>
                                                          <li>
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width={25}
                                                              height={25}
                                                              viewBox="0 0 24 24"
                                                            >
                                                              <path
                                                                d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                                                                fill="#7f56d9"
                                                              ></path>
                                                            </svg>
                                                            <span className="text-ec">
                                                              {"Seats Booked: " +
                                                                item.seats_booked}
                                                            </span>
                                                          </li>
                                                          <li>
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width={25}
                                                              height={25}
                                                              viewBox="0 0 24 24"
                                                            >
                                                              <path
                                                                d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"
                                                                fill="#7f56d9"
                                                              ></path>
                                                            </svg>
                                                            <span className="text-ec">
                                                              {"Seats Available: " +
                                                                item.seats_available}
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      {/* <p className="sesstion-detail-head">
                                     
                                      <span className="bookedtext">{"Seats Booked: " + item.seats_booked}</span>
                                      </p>
                                      <p className="sesstion-detail-head">
                                      <svg xmlns="http://www.w3.org/2000/svg"  width={24} height={24} viewBox="0 0 24 24" ><path d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z" fill="#7f56d9"></path></svg>
                                      <span className="bookedtext">{"Seats Available: " +
                                          item.seats_available}</span>
                                      </p> */}
                                                    </div>
                                                  </>
                                                );
                                              }
                                            )}
                                            <div className="Segmentbar">
                                              {!item?.is_host &&
                                                source != "broker" &&
                                                !_.isEmpty(priceInfo1)
                                                ? ProductCardPriceInfo(
                                                  priceInfo1.showText,
                                                  priceInfo1.textColor
                                                )
                                                : ""}
                                            </div>
                                            <div className="certificate-btn-sec">
                                              {item?.is_host ? (
                                                item.delivery_mode ===
                                                  "face_to_face" ||
                                                  item.delivery_mode ===
                                                  "blended_session" ? (
                                                  <></>
                                                ) : (
                                                  <>
                                                    {isSessionWithinOneHour(
                                                      item.date_time[0]
                                                        .start_date,
                                                      item.date_time[0]
                                                        .start_time,
                                                      item.date_time[0]
                                                        .end_date,
                                                      item.date_time[0]
                                                        .end_time,
                                                      item.timezoneAbbr
                                                    ) ? (
                                                      <button
                                                        type="button"
                                                        className={`startcourse-btn cursor-pointer`}
                                                        onClick={() => {
                                                          proceedToHost(item);
                                                        }}
                                                      >
                                                        Host
                                                      </button>
                                                    ) : (
                                                      <button
                                                        type="button"
                                                        className={`startcourse-btn cursor-not-allowed`}
                                                        disabled
                                                      >
                                                        Host
                                                      </button>
                                                    )}
                                                  </>
                                                )
                                              ) : (priceInfo1.isFree ||
                                                source == "broker") &&
                                                isUserRegistered() == false ? (
                                                <button
                                                  type="button"
                                                  className="startcourse-btn"
                                                  onClick={() =>
                                                    registerConfirm(item)
                                                  }
                                                >
                                                  {isLoggedIn
                                                    ? "Register now"
                                                    : "Signup to Register"}
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                      stroke="#6941C6"
                                                      strokeWidth="1.66667"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                  </svg>
                                                </button>
                                              ) : isSessionWithinOneHour(
                                                item.date_time[0]?.start_date,
                                                item.date_time[0]?.start_time,
                                                item.date_time[0]?.end_date,
                                                item.date_time[0]?.end_time,
                                                item.timezoneAbbr
                                              ) &&
                                                isUserRegistered() == true ? (
                                                item.delivery_mode ===
                                                  "face_to_face" ? (
                                                  <></>
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="startcourse-btn"
                                                    onClick={() =>
                                                      launchSession(item)
                                                    }
                                                  >
                                                    Join
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                        stroke="#6941C6"
                                                        strokeWidth="1.66667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                      />
                                                    </svg>
                                                  </button>
                                                )
                                              ) : isUserRegistered() == true ? (
                                                <>
                                                  {item.delivery_mode !==
                                                    "face_to_face" && (
                                                      <button
                                                        type="button"
                                                        className="startcourse-btn cursor-not-allowed"
                                                      >
                                                        Join
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="20"
                                                          height="20"
                                                          viewBox="0 0 20 20"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                            stroke="#6941C6"
                                                            strokeWidth="1.66667"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                          />
                                                        </svg>
                                                      </button>
                                                    )}
                                                  <button
                                                    type="button"
                                                    className={
                                                      item.cancel_request
                                                        ? "startcourse-btn disable-button"
                                                        : "startcourse-btn"
                                                    }
                                                    disabled={
                                                      item.cancel_request
                                                    }
                                                    onClick={() =>
                                                      cancelConfirm(item)
                                                    }
                                                    title={
                                                      item.cancel_request
                                                        ? "Your session cancellation request is still pending."
                                                        : ""
                                                    }
                                                  >
                                                    Cancel
                                                    
                                                  </button>
                                                </>
                                              ) : (
                                                <button
                                                  type="button"
                                                  className="startcourse-btn"
                                                  onClick={() =>
                                                    proceedToPurchase(
                                                      item,
                                                      priceInfo1
                                                    )
                                                  }
                                                >
                                                  Purchase
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                                      stroke="#6941C6"
                                                      strokeWidth="1.66667"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                    />
                                                  </svg>
                                                </button>
                                              )}
                                            </div>

                                            {(userRole === "manager" &&
                                              ((item?.purchased_info
                                                ?.selling_price === 0 &&
                                                item?.purchased_info
                                                  ?.is_purchased !== true) ||
                                                source === "broker")) ||
                                              (userRole === "manager" &&
                                                (from === "lp" ||
                                                  from === "oblp") &&
                                                source === "broker") ||
                                              (userRole === "manager" &&
                                                (from === "lp" ||
                                                  from === "oblp") &&
                                                item?.purchased_info
                                                  ?.is_purchased !== true &&
                                                item?.purchased_info
                                                  ?.selling_price === 0) ? (
                                              <div className="team-assign-sec   mt-4">
                                                <div className="text-box-rs d-flex align-items-center">
                                                  <div className="img-leftbef">
                                                    <img src="/images/TeamBenefit.svg" />
                                                  </div>
                                                  <div className="benefot">
                                                    <p className="m-0">
                                                      Get your team to benefit
                                                      from this session.
                                                    </p>
                                                  </div>
                                                </div>
                                                <div className="button-sec-assign mt-3 d-flex gap-2 align-items-center">
                                                  <button
                                                    type="button"
                                                    className="startcourse-btn"
                                                    onClick={() => {
                                                      dispatch(
                                                        setCurrentView(1)
                                                      );
                                                      setShow(true);
                                                      setSelectedSession(
                                                        source === "broker"
                                                          ? item.session_id
                                                          : item.product_id
                                                      );
                                                    }}
                                                  >
                                                    + Assign
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="startcourse-btn"
                                                    onClick={() => {
                                                      let parentId =
                                                        source === "broker"
                                                          ? item.session_id
                                                          : item.product_id;
                                                      let origin =
                                                        source === "xsel" ||
                                                          source === "ecom"
                                                          ? "xsel"
                                                          : "broker";
                                                      let pName =
                                                        fromCert === "true"
                                                          ? "Certificate"
                                                          : "Session";
                                                      navigate(
                                                        "/assigned-users?parentId=" +
                                                        parentId +
                                                        "&origin=" +
                                                        origin +
                                                        "&parentName=" +
                                                        pName +
                                                        "&isMobile=" +
                                                        false //isMobile
                                                      );
                                                    }}
                                                  >
                                                    View Assigned
                                                  </button>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>

                                  {source !== "broker" &&
                                    renderRemindMeSection()}
                                </>
                              )}
                              <CartPopUpComponent
                                isOpen={isOpen}
                                productData={headerProdData}
                                closeAction={() => setIsOpen(false)}
                                isSubscription={false}
                                setMainPageLoading={setIsLoading}
                              />
                            </div>
                          </Tab>
                          {isLoggedIn && (
                            <Tab eventKey="past-sessions" title="Past Sessions">
                              <div className="past-tab-content">
                                {isLoading ? (
                                  <div className="mt-5">
                                    <h4>
                                      <ShimmerScreen
                                        case="rect"
                                        width="100%"
                                        height="2rem"
                                      />
                                    </h4>

                                    <div className="price-bar">
                                      <ShimmerScreen
                                        case="rect"
                                        width="100%"
                                        height="2rem"
                                      />
                                    </div>

                                    <div className="Segmentbar">
                                      <ShimmerScreen
                                        case="rect"
                                        width="100%"
                                        height="4rem"
                                      />
                                    </div>
                                  </div>
                                ) : pastSessionListing != null &&
                                  pastSessionListing.length === 0 ? (
                                  <>
                                    <ErrorSectionSidebar />
                                    {source !== "broker" &&
                                      renderRemindMeSection()}
                                  </>
                                ) : (
                                  <>
                                    <div className="session-wrapper">
                                      {pastSessionListing.map((item, index) => {
                                        let priceInfo1 = getProcureInfo(
                                          item.purchased_info
                                        );
                                        console.log("item--", item);
                                        const isUserRegistered = () => {
                                          return item.is_registered; // Replace with your logic
                                        };
                                        return (
                                          <div
                                            className="mt-inner-sec mt-4"
                                            key={index}
                                          >
                                            <div className="d-flex user-table-box">
                                              <div className="brokarage-icon">
                                                <img
                                                  src={
                                                    !_.isEmpty(item?.provider)
                                                      ? item?.provider
                                                        ?.provider_img
                                                      : "https://cdnstg.training.com/xsel/image/6e139227-97e8-4726-9a03-2dd339cfff53.jpg"
                                                  }
                                                />
                                              </div>
                                              <h4 className="event-sidebar-title">
                                                {item.session_name}
                                              </h4>
                                            </div>

                                            {item.date_time.map(
                                              (segment, i) => {
                                                return (
                                                  <>
                                                    <div
                                                      className="Segmentbar"
                                                      key={i}
                                                    >
                                                      <p className="sesstion-detail-head">
                                                        {segment.segment_title}
                                                      </p>
                                                      <p className="sesstion-detail">
                                                        {formatStartDateTime(
                                                          segment.start_date,
                                                          segment.start_time,
                                                          item.timezoneAbbr
                                                        )}
                                                      </p>
                                                      <p className="sesstion-detail">
                                                        {formatEndDateTime(
                                                          segment.end_date,
                                                          segment.end_time,
                                                          item.timezoneAbbr
                                                        )}
                                                      </p>
                                                    </div>
                                                  </>
                                                );
                                              }
                                            )}

                                            <div className="Segmentbar">
                                              <div className="event-details">
                                                <ul>
                                                  <li>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="25"
                                                      height="25"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M15.3033 14.4701L10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701ZM10 12.5001C11.8409 12.5001 13.3333 11.0077 13.3333 9.16675C13.3333 7.3258 11.8409 5.83341 10 5.83341C8.15905 5.83341 6.66667 7.3258 6.66667 9.16675C6.66667 11.0077 8.15905 12.5001 10 12.5001ZM10 10.8334C9.0795 10.8334 8.33333 10.0872 8.33333 9.16675C8.33333 8.24627 9.0795 7.50008 10 7.50008C10.9205 7.50008 11.6667 8.24627 11.6667 9.16675C11.6667 10.0872 10.9205 10.8334 10 10.8334Z"
                                                        fill="#6941C6"
                                                      />
                                                    </svg>
                                                    <span className="text-ec">
                                                      {item.delivery_mode ===
                                                        "blended_session" ? (
                                                        <>
                                                          {"In-Person/Virtual (" +
                                                            item.location +
                                                            ")"}
                                                        </>
                                                      ) : item.delivery_mode ===
                                                        "face_to_face" ? (
                                                        <>
                                                          {"In-Person (" +
                                                            item.location +
                                                            ")"}
                                                        </>
                                                      ) : item.delivery_mode ===
                                                        "virtual_interactive" ||
                                                        item.delivery_mode ===
                                                        "virtual_broadcast" ? (
                                                        "Virtual"
                                                      ) : (
                                                        "Live"
                                                      )}
                                                    </span>
                                                  </li>
                                                  <li>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width={25}
                                                      height={25}
                                                      viewBox="0 0 24 24"
                                                    >
                                                      <path
                                                        d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
                                                        fill="#7f56d9"
                                                      ></path>
                                                    </svg>
                                                    <span className="text-ec">
                                                      {"Seats Booked: " +
                                                        item.seats_booked}
                                                    </span>
                                                  </li>
                                                  <li>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width={25}
                                                      height={25}
                                                      viewBox="0 0 24 24"
                                                    >
                                                      <path
                                                        d="M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"
                                                        fill="#7f56d9"
                                                      ></path>
                                                    </svg>
                                                    <span className="text-ec">
                                                      {"Seats Available: " +
                                                        item.seats_available}
                                                    </span>
                                                  </li>
                                                </ul>
                                              </div>
                                              {/* <p className="sesstion-detail-head">
                                  {"Seats Booked: " + item.seats_booked}
                                </p>
                                <p className="sesstion-detail-head">
                                  {"Seats Available: " + item.seats_available}
                                </p> */}
                                            </div>

                                            <div className="certificate-btn-sec">
                                              {source != "broker" &&
                                                !_.isEmpty(priceInfo1)
                                                ? ProductCardPriceInfo(
                                                  priceInfo1.showText,
                                                  priceInfo1.textColor
                                                )
                                                : ""}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                    {source !== "broker" &&
                                      renderRemindMeSection()}
                                  </>
                                )}
                              </div>
                            </Tab>
                          )}
                        </Tabs>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row mt-3">
              {!_.isEmpty(upcomingSessionDetail) && (
                <div className="col-xl-8 col-md-7 col-12 discussion-workflow">
                  <h4 className="discussion-title mb-0">
                    {t("discussionBoard")}
                  </h4>
                  <DetailPageDiscussComponent
                    id={sessionId}
                    code={event_code}
                    type={"workshop"}
                    source={source}
                    isMobile={false}
                    isShow={
                      new Date() <
                      new Date(
                        `${upcomingSessionDetail?.date_time[0]?.end_date.replace(
                          /(\d{2})-(\d{2})-(\d{4})/,
                          "$3-$1-$2"
                        )}T${upcomingSessionDetail?.date_time[0]?.end_time
                        }:00.000Z`
                      )
                    }
                  />
                </div>
              )}
              <div className="col-xl-4 col-md-5 col-12">
                <div className="workshop-resources">
                  {!_.isEmpty(upcomingSessionDetail) && (
                    <div className="bnt-join-wra d-flex justify-content-between gap-3">
                      {isSessionLoading ? (
                        <ShimmerScreen case="rect" height="2rem" width="5rem" />
                      ) : (
                        upcomingSessionDetail?.is_host ?
                          <button
                            className="btn-primary active-page"
                            disabled={
                              !JoinButtonEnable(
                                upcomingSessionDetail?.date_time[0]?.start_date,
                                upcomingSessionDetail?.date_time[0]?.start_time,
                                upcomingSessionDetail?.date_time[0]?.end_date,
                                upcomingSessionDetail?.date_time[0]?.end_time
                              )
                            }
                            onClick={() =>
                              window.open(
                                upcomingSessionDetail?.date_time[0]?.join_url,
                                "_blank"
                              )
                            }
                          >
                            {t("clickToHost")}
                          </button>
                          :
                          <button
                            className="btn-primary active-page"
                            disabled={
                              !JoinButtonEnable(
                                upcomingSessionDetail?.date_time[0]?.start_date,
                                upcomingSessionDetail?.date_time[0]?.start_time,
                                upcomingSessionDetail?.date_time[0]?.end_date,
                                upcomingSessionDetail?.date_time[0]?.end_time
                              )
                            }
                            onClick={() =>
                              window.open(
                                upcomingSessionDetail?.date_time[0]?.join_url,
                                "_blank"
                              )
                            }
                          >
                            {t("clickToJoin")}
                          </button>
                      )}

                      {isSessionLoading ? (
                        <ShimmerScreen case="rect" height="2rem" width="5rem" />
                      ) :

                        upcomingSessionDetail.multiple_check > 1 ?
                        <Dropdown>
                        <Dropdown.Toggle variant="primary" id="dropdown-basic">
                          {
                            upcomingSessionDetail.enableEdit ?
                            t("Click to Cancel") : t("decline")
                          }
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item href="#" onClick={() => {
                            cancelConfirm(upcomingSessionDetail, 'session')
                          }}>Occurence</Dropdown.Item>
                          <Dropdown.Item href="#"
                            onClick={() => {
                              cancelConfirm(upcomingSessionDetail, 'workshop')
                            }}
                          >Workshop</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                          :
                          <button
                            type="button"
                            className={
                              upcomingSessionDetail?.cancel_request
                                ? "startcourse-btn canclebtn disable-button"
                                : "startcourse-btn canclebtn"
                            }
                            disabled={upcomingSessionDetail?.cancel_request}
                            onClick={() => {
                              if (userRole === "manager" && upcomingSessionDetail.multiple_check > 1) {
                                cancelConfirmRecurr(upcomingSessionDetail)
                              } else {
                                cancelConfirm(upcomingSessionDetail)
                              }

                            }}
                            title={
                              upcomingSessionDetail?.cancel_request
                                ? "Your workshop cancellation request is still pending."
                                : ""
                            }
                          >
                            {userRole === "manager"
                              ? t("Click to Cancel")
                              : t("decline")}
                          </button>

                        // <button
                        //   type="button"
                        //   className={
                        //     upcomingSessionDetail?.cancel_request
                        //       ? "startcourse-btn canclebtn disable-button"
                        //       : "startcourse-btn canclebtn"
                        //   }
                        //   disabled={upcomingSessionDetail?.cancel_request}
                        //   onClick={() => {
                        //     if(userRole==="manager" && upcomingSessionDetail.multiple_check>1){
                        //     cancelConfirmRecurr(upcomingSessionDetail)
                        //     }else{
                        //     cancelConfirm(upcomingSessionDetail)
                        //     }

                        //   }}
                        //   title={
                        //     upcomingSessionDetail?.cancel_request
                        //       ? "Your workshop cancellation request is still pending."
                        //       : ""
                        //   }
                        // >
                        //   {userRole === "manager"
                        //     ? t("Click to Cancel")
                        //     : t("decline")}
                        // </button>
                      }
                    </div>
                  )}
                  {!_.isEmpty(upcomingSessionDetail?.workshop_resource) && (
                    <div className="resoucesbox d-flex flex-column">
                      <div className="resouces-head">
                        {t("workshopResources")}
                      </div>
                      <div className="d-flex gap-2 flex-wrap">
                        {upcomingSessionDetail?.workshop_resource.map(
                          (item) => {
                            return item?.type === "pdf" ? (
                              <div className="respicebopx cursor-pointer" onClick={() => { window.open(item?.url, "_blank") }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="33"
                                  height="32"
                                  viewBox="0 0 33 32"
                                  fill="none"
                                >
                                  <path
                                    d="M8.5 0C7.4 0 6.5 0.9 6.5 2V30C6.5 31.1 7.4 32 8.5 32H28.5C29.6 32 30.5 31.1 30.5 30V8L22.5 0H8.5Z"
                                    fill="#E2E5E7"
                                  />
                                  <path
                                    d="M24.5 8H30.5L22.5 0V6C22.5 7.1 23.4 8 24.5 8Z"
                                    fill="#B0B7BD"
                                  />
                                  <path
                                    d="M30.5 14L24.5 8H30.5V14Z"
                                    fill="#CAD1D8"
                                  />
                                  <path
                                    d="M26.5 26C26.5 26.55 26.05 27 25.5 27H3.5C2.95 27 2.5 26.55 2.5 26V16C2.5 15.45 2.95 15 3.5 15H25.5C26.05 15 26.5 15.45 26.5 16V26Z"
                                    fill="#F15642"
                                  />
                                  <path
                                    d="M6.85938 18.9465C6.85938 18.6825 7.06737 18.3945 7.40237 18.3945H9.24937C10.2894 18.3945 11.2254 19.0905 11.2254 20.4245C11.2254 21.6885 10.2894 22.3925 9.24937 22.3925H7.91437V23.4485C7.91437 23.8005 7.69037 23.9995 7.40237 23.9995C7.13837 23.9995 6.85938 23.8005 6.85938 23.4485V18.9465ZM7.91437 19.4015V21.3935H9.24937C9.78537 21.3935 10.2094 20.9205 10.2094 20.4245C10.2094 19.8655 9.78537 19.4015 9.24937 19.4015H7.91437Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M12.7903 23.9978C12.5263 23.9978 12.2383 23.8538 12.2383 23.5028V18.9608C12.2383 18.6738 12.5263 18.4648 12.7903 18.4648H14.6213C18.2753 18.4648 18.1953 23.9978 14.6933 23.9978H12.7903ZM13.2943 19.4408V23.0228H14.6213C16.7803 23.0228 16.8763 19.4408 14.6213 19.4408H13.2943Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M19.4913 19.5058V20.7768H21.5303C21.8183 20.7768 22.1063 21.0648 22.1063 21.3438C22.1063 21.6078 21.8183 21.8238 21.5303 21.8238H19.4913V23.5028C19.4913 23.7828 19.2923 23.9978 19.0123 23.9978C18.6603 23.9978 18.4453 23.7828 18.4453 23.5028V18.9608C18.4453 18.6738 18.6613 18.4648 19.0123 18.4648H21.8193C22.1713 18.4648 22.3793 18.6738 22.3793 18.9608C22.3793 19.2168 22.1713 19.5048 21.8193 19.5048H19.4913V19.5058Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M25.5 27H6.5V28H25.5C26.05 28 26.5 27.55 26.5 27V26C26.5 26.55 26.05 27 25.5 27Z"
                                    fill="#CAD1D8"
                                  />
                                </svg>
                                <p>{item?.name}</p>
                              </div>
                            ) : (
                              <div className="respicebopx cursor-pointer" onClick={() => { window.open(item?.url, "_blank") }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M4.56203 18.8294C12.3617 20.1821 20.1616 20.1366 27.9613 18.8294V7.98575C27.9613 7.8622 27.9213 7.74208 27.8472 7.64332L22.7108 0.794738C22.603 0.651055 22.4338 0.566406 22.2542 0.566406H6.27417C5.82011 0.566406 5.38454 0.746798 5.06348 1.06786C4.74242 1.38906 4.56203 1.82449 4.56203 2.27855V15.4051C4.56203 16.2527 4.36328 16.9711 4.36328 17.5438C4.36328 18.3355 4.56203 18.8294 4.56203 18.8294Z"
                                    fill="#D8DFE3"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.13672 17.3477V29.6707C1.13672 30.1248 1.31711 30.5604 1.63817 30.8814C1.95923 31.2025 2.3948 31.3829 2.84886 31.3829H29.1018C29.5559 31.3829 29.9913 31.2025 30.3125 30.8814C30.6336 30.5604 30.814 30.1248 30.814 29.6707C30.814 27.4838 30.814 22.7263 30.814 20.5394C30.814 20.0853 30.6336 19.6497 30.3125 19.3287C29.9913 19.0076 29.5559 18.8272 29.1018 18.8272H3.41963C2.69148 18.8272 1.13672 17.3477 1.13672 17.3477Z"
                                    fill="#2D98DB"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M2.84886 18.8305C2.32782 18.8305 1.94745 18.6192 1.66748 18.3589C1.40409 18.114 1.13672 17.6824 1.13672 17.1184C1.13672 16.7564 1.31711 16.2288 1.63817 15.9077C1.95923 15.5866 2.3948 15.4062 2.84886 15.4062H4.56101V18.8305C4.56101 18.8305 4.70771 18.8305 2.84886 18.8305Z"
                                    fill="#216896"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M22.2539 0.566406V6.2736C22.2539 6.72766 22.4343 7.16323 22.7554 7.4843C23.0764 7.80536 23.5119 7.98575 23.9661 7.98575H27.961C27.961 7.8622 27.921 7.74208 27.8469 7.64332L22.7104 0.794738C22.6026 0.651055 22.4335 0.566406 22.2539 0.566406Z"
                                    fill="#AFBDC7"
                                  />
                                  <path
                                    d="M9.69922 7.98438H17.1186"
                                    stroke="black"
                                    stroke-width="1.14097"
                                    stroke-miterlimit="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M9.69922 11.4102H22.8256"
                                    stroke="black"
                                    stroke-width="1.14097"
                                    stroke-miterlimit="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M9.69922 14.8359H22.8256"
                                    stroke="black"
                                    stroke-width="1.14097"
                                    stroke-miterlimit="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.3671 24.5371C12.3671 23.7804 12.0664 23.0545 11.5313 22.5194C10.9961 21.9842 10.2703 21.6836 9.51353 21.6836C8.49309 21.6836 7.51607 21.6836 7.51607 21.6836C7.20076 21.6836 6.94531 21.939 6.94531 22.2544V27.9614C6.94531 28.2767 7.20076 28.5322 7.51607 28.5322H9.51353C10.2703 28.5322 10.9961 28.2315 11.5313 27.6964C12.0664 27.1612 12.3671 26.4354 12.3671 25.6786V24.5371ZM11.2257 24.5371V25.6786C11.2257 26.1327 11.0453 26.5681 10.7242 26.8893C10.4032 27.2104 9.96759 27.3908 9.51353 27.3908H8.0867V22.825H9.51353C9.96759 22.825 10.4032 23.0054 10.7242 23.3264C11.0453 23.6476 11.2257 24.0831 11.2257 24.5371Z"
                                    fill="#D8DFE3"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M22.1543 28.5908H22.4806C23.4986 28.5908 24.4231 27.9969 24.8464 27.0709C24.9054 26.9419 24.955 26.8334 24.955 26.8334L24.4372 27.1639C24.2118 26.3468 24.0166 26.2457 23.924 26.3699L23.9169 26.3588L23.8082 26.5963C23.5707 27.116 23.0519 27.4494 22.4806 27.4494H22.1543C21.2088 27.4494 20.4422 26.6828 20.4422 25.7372V24.5957C20.4422 23.6502 21.2088 22.8836 22.1543 22.8836H22.4806C23.0519 22.8836 23.5707 23.217 23.8082 23.7365L23.9169 23.9741L23.9184 23.9773L23.9229 23.987L23.9303 24.0015L23.9333 24.0078L23.9356 24.0121C24.1114 24.344 24.4372 24.3104 24.4372 24.3104L24.4704 24.2993C24.6164 24.2469 25.1862 24.0054 24.955 23.4995L24.8464 23.262C24.4231 22.3361 23.4986 21.7422 22.4806 21.7422H22.1543C20.5783 21.7422 19.3008 23.0197 19.3008 24.5957V25.7372C19.3008 27.3132 20.5783 28.5908 22.1543 28.5908Z"
                                    fill="#D8DFE3"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.8615 21.6836C14.3247 21.6836 13.0078 23.1869 13.0078 25.1079C13.0078 27.0289 14.3247 28.5322 15.8615 28.5322C17.3983 28.5322 18.715 27.0289 18.715 25.1079C18.715 23.1869 17.3983 21.6836 15.8615 21.6836ZM15.8615 22.825C16.8453 22.825 17.5736 23.878 17.5736 25.1079C17.5736 26.3378 16.8453 27.3908 15.8615 27.3908C14.8776 27.3908 14.1493 26.3378 14.1493 25.1079C14.1493 23.878 14.8776 22.825 15.8615 22.825Z"
                                    fill="#D8DFE3"
                                  />
                                </svg>
                                <p>{item?.name}</p>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  )}
                  {!_.isEmpty(
                    upcomingSessionDetail?.workshop_prerequisites
                  ) && (
                      <div className="resoucesbox d-flex flex-column">
                        <div className="resouces-head">
                          {t("workshopPrerequisites")}
                        </div>
                        <div className="d-flex gap-2 flex-wrap">
                          {!_.isEmpty(
                            upcomingSessionDetail?.workshop_prerequisites
                          ) &&
                            upcomingSessionDetail?.workshop_prerequisites?.map(
                              (item) => {
                                return item?.type === "pdf" ? (
                                  <div className="respicebopx cursor-pointer" onClick={() => { window.open(item?.url, "_blank") }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="33"
                                      height="32"
                                      viewBox="0 0 33 32"
                                      fill="none"
                                    >
                                      <path
                                        d="M8.5 0C7.4 0 6.5 0.9 6.5 2V30C6.5 31.1 7.4 32 8.5 32H28.5C29.6 32 30.5 31.1 30.5 30V8L22.5 0H8.5Z"
                                        fill="#E2E5E7"
                                      />
                                      <path
                                        d="M24.5 8H30.5L22.5 0V6C22.5 7.1 23.4 8 24.5 8Z"
                                        fill="#B0B7BD"
                                      />
                                      <path
                                        d="M30.5 14L24.5 8H30.5V14Z"
                                        fill="#CAD1D8"
                                      />
                                      <path
                                        d="M26.5 26C26.5 26.55 26.05 27 25.5 27H3.5C2.95 27 2.5 26.55 2.5 26V16C2.5 15.45 2.95 15 3.5 15H25.5C26.05 15 26.5 15.45 26.5 16V26Z"
                                        fill="#F15642"
                                      />
                                      <path
                                        d="M6.85938 18.9465C6.85938 18.6825 7.06737 18.3945 7.40237 18.3945H9.24937C10.2894 18.3945 11.2254 19.0905 11.2254 20.4245C11.2254 21.6885 10.2894 22.3925 9.24937 22.3925H7.91437V23.4485C7.91437 23.8005 7.69037 23.9995 7.40237 23.9995C7.13837 23.9995 6.85938 23.8005 6.85938 23.4485V18.9465ZM7.91437 19.4015V21.3935H9.24937C9.78537 21.3935 10.2094 20.9205 10.2094 20.4245C10.2094 19.8655 9.78537 19.4015 9.24937 19.4015H7.91437Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M12.7903 23.9978C12.5263 23.9978 12.2383 23.8538 12.2383 23.5028V18.9608C12.2383 18.6738 12.5263 18.4648 12.7903 18.4648H14.6213C18.2753 18.4648 18.1953 23.9978 14.6933 23.9978H12.7903ZM13.2943 19.4408V23.0228H14.6213C16.7803 23.0228 16.8763 19.4408 14.6213 19.4408H13.2943Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M19.4913 19.5058V20.7768H21.5303C21.8183 20.7768 22.1063 21.0648 22.1063 21.3438C22.1063 21.6078 21.8183 21.8238 21.5303 21.8238H19.4913V23.5028C19.4913 23.7828 19.2923 23.9978 19.0123 23.9978C18.6603 23.9978 18.4453 23.7828 18.4453 23.5028V18.9608C18.4453 18.6738 18.6613 18.4648 19.0123 18.4648H21.8193C22.1713 18.4648 22.3793 18.6738 22.3793 18.9608C22.3793 19.2168 22.1713 19.5048 21.8193 19.5048H19.4913V19.5058Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M25.5 27H6.5V28H25.5C26.05 28 26.5 27.55 26.5 27V26C26.5 26.55 26.05 27 25.5 27Z"
                                        fill="#CAD1D8"
                                      />
                                    </svg>
                                    <p>{item?.name}</p>
                                  </div>
                                ) : (
                                  <div className="respicebopx cursor-pointer" onClick={() => { window.open(item?.url, "_blank") }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="33"
                                      height="32"
                                      viewBox="0 0 33 32"
                                      fill="none"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M31.4098 28.8507H10.7188V7.66906L15.7159 2.67188H31.4098V28.8507Z"
                                        fill="#E0DFE1"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M29.2691 26.7101H8.57812V5.52844L13.5753 0.53125H29.2691V26.7101Z"
                                        fill="#F0F0F0"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8.57812 5.52844L13.5753 0.53125V5.52844H8.57812Z"
                                        fill="#E0DFE1"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M26.7641 4.56331V12.1929C26.7641 12.8379 26.2364 13.3656 25.5914 13.3656H17.9618C17.3168 13.3656 16.7891 12.8379 16.7891 12.1929V4.56331C16.7891 3.91831 17.3168 3.39062 17.9618 3.39062H25.5914C26.2364 3.39062 26.7641 3.91831 26.7641 4.56331Z"
                                        fill="#43A2FF"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M26.7641 11.9762V12.1933C26.7641 12.8383 26.2364 13.366 25.5914 13.366H17.9618C17.3168 13.366 16.7891 12.8383 16.7891 12.1933V11.9788L19.8966 8.76237C19.9596 8.69719 20.0376 8.66406 20.1283 8.66406C20.2189 8.66406 20.2969 8.69719 20.3599 8.76237L22.4815 10.9584L23.8451 9.72213C23.9684 9.61038 24.1546 9.61044 24.2778 9.72213L26.7641 11.9762Z"
                                        fill="#6F6571"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M22.6336 7.94681C23.0729 7.94681 23.4312 7.5885 23.4312 7.14919C23.4312 6.70987 23.0729 6.35156 22.6336 6.35156C22.1942 6.35156 21.8359 6.70987 21.8359 7.14919C21.836 7.5885 22.1943 7.94681 22.6336 7.94681Z"
                                        fill="#FFD54F"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.86955 23.4766L1.94274 29.4034C1.47218 29.8739 1.47224 30.6439 1.94274 31.1144C2.41324 31.585 3.18324 31.5851 3.6538 31.1144L9.44749 25.3208L7.86955 23.4766Z"
                                        fill="#706C64"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M4.54555 30.2228C3.97518 29.6524 3.40487 29.0821 2.83449 28.5117L1.94274 29.4035C1.47218 29.874 1.47224 30.644 1.94274 31.1145C2.41324 31.5851 3.18324 31.5852 3.6538 31.1145L4.54555 30.2228Z"
                                        fill="#8F8B81"
                                      />
                                      <path
                                        d="M13.9524 26.8419C17.651 26.2654 20.1819 22.7998 19.6054 19.1013C19.0289 15.4028 15.5633 12.8719 11.8648 13.4484C8.16622 14.0248 5.63531 17.4904 6.2118 21.189C6.78829 24.8875 10.2539 27.4184 13.9524 26.8419Z"
                                        fill="#43A2FF"
                                      />
                                      <path
                                        d="M14.8023 24.5463C17.2285 23.5035 18.3499 20.6913 17.3071 18.2651C16.2643 15.8389 13.4521 14.7174 11.0259 15.7602C8.59965 16.8031 7.47819 19.6153 8.52101 22.0415C9.56383 24.4677 12.376 25.5892 14.8023 24.5463Z"
                                        fill="#C9F0FF"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.9152 15.8322C15.2926 15.8322 17.2272 17.7663 17.2272 20.1439C17.2272 22.5212 15.2926 24.4559 12.9152 24.4559C10.5375 24.4559 8.60319 22.5212 8.60319 20.1439C8.60319 17.7663 10.5375 15.8322 12.9152 15.8322ZM12.9152 25.3932C15.8096 25.3932 18.1646 23.0382 18.1646 20.1439C18.1646 17.2494 15.8096 14.8945 12.9152 14.8945C10.0208 14.8945 7.66581 17.2495 7.66581 20.1439C7.66581 23.0383 10.0207 25.3932 12.9152 25.3932ZM14.7519 11.1671H11.0784C10.8196 11.1671 10.6097 10.9572 10.6097 10.6984C10.6097 10.4393 10.8196 10.2297 11.0784 10.2297H14.7519C15.0107 10.2297 15.2209 10.4393 15.2209 10.6984C15.2209 10.9571 15.0107 11.1671 14.7519 11.1671ZM10.6097 8.0315C10.6097 7.77238 10.8196 7.5625 11.0784 7.5625H14.7519C15.0107 7.5625 15.2209 7.77238 15.2209 8.0315C15.2209 8.29031 15.0107 8.50019 14.7519 8.50019H11.0784C10.8196 8.50019 10.6097 8.29031 10.6097 8.0315ZM22.6357 6.82175C22.8171 6.82175 22.9647 6.96913 22.9647 7.15069C22.9647 7.332 22.817 7.47937 22.6357 7.47937C22.4545 7.47937 22.3071 7.332 22.3071 7.15069C22.3071 6.96913 22.4544 6.82175 22.6357 6.82175ZM22.6357 8.41706C23.3341 8.41706 23.9021 7.84906 23.9021 7.15069C23.9021 6.45238 23.3341 5.88431 22.6357 5.88431C21.9377 5.88431 21.3697 6.45238 21.3697 7.15069C21.3696 7.84906 21.9377 8.41706 22.6357 8.41706ZM17.6947 3.85925C17.4553 3.85925 17.2602 4.05413 17.2602 4.29344V10.8183L19.7932 8.19625C19.8816 8.10456 20.0034 8.053 20.1301 8.053C20.2577 8.053 20.3795 8.10456 20.4677 8.19625L22.5052 10.3054L23.7489 9.17788C23.9272 9.01606 24.1996 9.01606 24.3785 9.17788L26.2972 10.9177V4.29344C26.2972 4.05406 26.1026 3.85925 25.8627 3.85925H17.6947ZM25.8626 12.8965H17.6947C17.4553 12.8965 17.2602 12.7016 17.2602 12.462V12.1675L20.1301 9.19644L23.1115 12.2819C23.2035 12.3771 23.3258 12.4249 23.4484 12.4249C23.5658 12.4249 23.6834 12.3813 23.7739 12.2934C23.9602 12.1136 23.9652 11.8167 23.7851 11.6304L23.1572 10.9799L24.0633 10.158L26.2971 12.1831V12.462C26.2971 12.7016 26.1026 12.8965 25.8626 12.8965ZM17.6947 13.8339H25.8627C26.6197 13.8339 27.2346 13.2184 27.2346 12.462V4.29344C27.2346 3.53706 26.6196 2.92188 25.8627 2.92188H17.6947C16.9383 2.92188 16.3225 3.53706 16.3225 4.29344V12.462C16.3225 13.2184 16.9383 13.8339 17.6947 13.8339ZM30.939 28.3814V3.13969H29.7366V26.7101C29.7366 26.9689 29.5264 27.1788 29.2676 27.1788H14.6591C14.1002 27.3176 13.5165 27.3913 12.9151 27.3913C12.3188 27.3913 11.7396 27.3188 11.1851 27.1819V28.3814L30.939 28.3814ZM4.54644 29.5614L3.49819 28.5126L7.29581 24.715C7.60888 25.0994 7.96025 25.4508 8.34406 25.7638L4.54644 29.5614ZM2.79906 30.9999C2.99775 30.9999 3.184 30.9233 3.32344 30.7844L3.88325 30.2238L2.83531 29.1759L2.27469 29.7362C1.98581 30.0251 1.98581 30.495 2.27469 30.7844C2.41375 30.9233 2.60031 30.9999 2.79906 30.9999ZM12.9152 13.8339C9.43594 13.8339 6.60519 16.6646 6.60519 20.1439C6.60519 23.6231 9.43594 26.4539 12.9152 26.4539C16.3947 26.4539 19.2252 23.6231 19.2252 20.1439C19.2251 16.6646 16.3947 13.8339 12.9152 13.8339ZM9.04594 5.99725V14.0187C10.1658 13.3083 11.4935 12.8965 12.9152 12.8965C15.1758 12.8965 17.1971 13.9365 18.5271 15.5634H26.7658C27.0253 15.5634 27.2345 15.7732 27.2345 16.0321C27.2345 16.2909 27.0252 16.5007 26.7658 16.5007H19.1783C19.4919 17.0376 19.7384 17.6177 19.9058 18.2303H26.7659C27.0253 18.2303 27.2346 18.4401 27.2346 18.6989C27.2346 18.9578 27.0252 19.1676 26.7659 19.1676H20.0971C20.1401 19.4869 20.1626 19.8126 20.1626 20.1439C20.1626 20.3983 20.1496 20.6495 20.1239 20.8971H26.7658C27.0253 20.8971 27.2345 21.1069 27.2345 21.3658C27.2345 21.6246 27.0252 21.8344 26.7658 21.8344H19.9633C19.8171 22.4446 19.5933 23.0244 19.3033 23.5639H26.7658C27.0253 23.5639 27.2345 23.7738 27.2345 24.0326C27.2345 24.2914 27.0252 24.5013 26.7658 24.5013H18.7028C18.1864 25.1858 17.5514 25.7765 16.8289 26.2413H28.7989V0.999875H14.0427V5.52856C14.0427 5.78737 13.8328 5.99725 13.574 5.99725H9.04594ZM13.1053 1.66287V5.05988H9.70831L13.1053 1.66287ZM31.4077 2.20231H29.7366V0.531188C29.7366 0.272375 29.5264 0.0625 29.2676 0.0625H13.574C13.4496 0.0625 13.3302 0.112 13.2427 0.199875L8.24531 5.19694C8.15775 5.28506 8.10825 5.40419 8.10825 5.52856V14.7253C6.61194 16.0539 5.66781 17.9906 5.66781 20.1439C5.66781 21.5349 6.06225 22.8358 6.74463 23.9406L1.61225 29.0732C0.957813 29.7276 0.956938 30.7924 1.61225 31.4477C1.92825 31.7631 2.3495 31.9376 2.79906 31.9376C3.24831 31.9376 3.67013 31.7631 3.98581 31.4477L9.1185 26.3151C9.47575 26.535 9.85337 26.7257 10.2478 26.8825V28.8501C10.2478 29.1089 10.4577 29.3188 10.7165 29.3188H31.4078C31.6666 29.3188 31.8764 29.1089 31.8764 28.8501V2.671C31.8764 2.41219 31.6665 2.20231 31.4077 2.20231Z"
                                        fill="black"
                                      />
                                    </svg>
                                    <p className="d-flex gap-2">
                                      Read Article{" "}
                                      <span className="linkr">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="12"
                                          height="12"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                        >
                                          <g clip-path="url(#clip0_3080_79968)">
                                            <path
                                              d="M11.625 0.75V4.125C11.625 4.33228 11.4573 4.5 11.25 4.5C11.0427 4.5 10.875 4.33228 10.875 4.125V1.65525L5.51512 7.01513C5.44191 7.08834 5.34591 7.125 5.25 7.125C5.15409 7.125 5.05809 7.08834 4.98488 7.01513C4.83834 6.86859 4.83834 6.63131 4.98488 6.48487L10.3448 1.125H7.875C7.66772 1.125 7.5 0.957281 7.5 0.75C7.5 0.542719 7.66772 0.375 7.875 0.375H11.25C11.4573 0.375 11.625 0.542719 11.625 0.75ZM10.125 10.5V6C10.125 5.79272 9.95728 5.625 9.75 5.625C9.54272 5.625 9.375 5.79272 9.375 6V10.5C9.375 10.7069 9.20691 10.875 9 10.875H1.5C1.29309 10.875 1.125 10.7069 1.125 10.5V3C1.125 2.79309 1.29309 2.625 1.5 2.625H6C6.20728 2.625 6.375 2.45728 6.375 2.25C6.375 2.04272 6.20728 1.875 6 1.875H1.5C0.879656 1.875 0.375 2.37966 0.375 3V10.5C0.375 11.1203 0.879656 11.625 1.5 11.625H9C9.62034 11.625 10.125 11.1203 10.125 10.5Z"
                                              fill="#135591"
                                              stroke="#135591"
                                              stroke-width="0.5"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_3080_79968">
                                              <rect
                                                width="12"
                                                height="12"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                    </p>
                                  </div>
                                );
                              }
                            )}
                        </div>
                      </div>
                    )}
                  {!_.isEmpty(upcomingSessionDetail?.video_details) &&
                    upcomingSessionDetail?.video_details.map((item) => {
                      return (
                        <div className="videovox">
                          <div className="inner-coursecard p-0">
                            <div className="card-img-section  position-relative cursor-pointer product-img-sec">
                              {/* <img
                                className="cardthum"
                                src="https://cdnstg.training.com/xsel/image/f5ac38a7-9c01-4d7f-a640-d9ad2c8a4250.jpg"
                                alt="A Leading Teams: Building Effective Team Cultures"
                                loading="lazy"
                              /> */}
                              <iframe
                                width="300"
                                height="200"
                                src={item?.url}
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                              ></iframe>
                              {/* <button className="playbtn"></button> */}
                              {/* <span className="duration-bar">
                                {moment(item?.duration, "mm:ss").format(
                                  "m [Mins] s [Secs]"
                                )}
                              </span> */}
                            </div>{" "}
                          </div>
                          <p>{item?.name}</p>
                        </div>
                      );
                    })}

                  {!_.isEmpty(upcomingSessionDetail?.instructor) && (
                    <div className="resoucesbox d-flex flex-column">
                      <div className="resouces-head">
                        {upcomingSessionDetail?.instructor?.length > 1 ? t("trainers") : t("trainer")}
                        {upcomingSessionDetail?.instructor?.length > 1
                          ? `(${upcomingSessionDetail?.instructor?.length})`
                          : ""}
                      </div>
                      <ul className="list-particiapte p-0">
                        {upcomingSessionDetail?.instructor.map((item) => {
                          return (
                            <li className="d-flex gap-3">
                              <div className="img-buse">
                                {
                                  item?.profile_image ? <img src={item?.profile_image} alt="" />
                                    :
                                    <img src="/images/profile_avatar.png" alt="" />
                                }
                              </div>
                              <div className="nameise">
                                {item?.name}{item.is_declined && "(Declined)"}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                  {!_.isEmpty(upcomingSessionDetail?.participanents) && (
                    <div className="resoucesbox d-flex flex-column">
                      <div className="resouces-head">
                        {upcomingSessionDetail?.participanents?.length > 1 ? t("participants") : t("participant")}
                        {upcomingSessionDetail?.participanents?.length > 1
                          ? `(${upcomingSessionDetail?.participanents?.length})`
                          : ""}
                      </div>
                      <ul className="list-particiapte p-0">
                        {upcomingSessionDetail?.participanents.map((item) => {
                          return (
                            <li className="d-flex gap-3">
                              <div className="img-buse">
                                {
                                  item?.profile_image ? <img src={item?.profile_image} alt="" />
                                    :
                                    <img src="/images/profile_avatar.png" alt="" />
                                }
                              </div>
                              <div className="nameise">
                                {item?.display_name}{item.is_declined && "(Declined)"}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <ConfirmModal
        confirmModal={infoModal}
        setConfirmModal={setInfoModal}
        showModalMsg={showInfoModalMsg}
        isConfirm={isConfirm}
        confirmId={""}
        confirmAction={() => { }}
        isRightIcon={!isConfirm}
      />
      <AssignCourseModal
        show={show}
        parentName={
          fromCert === "true" ? "Certificate Session" : "Event Session"
        }
        parentId={selectedSession}
        setShow={setShow}
        origin={source === "xsel" || source === "ecom" ? "xsel" : "broker"}
        isMobile={false}
      />
      {confirmModal ? (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={true}
          confirmId={sessionDataForModal}
          confirmAction={clickedItem === 2 ? cancelSession : proceedToRegister}
          clickedItem={clickedItem}
          noAction={() => { }}
        />
      ) : (
        ""
      )}
      <RecurrConfirmModal
        confirmModal={confirmModalRecurr}
        setConfirmModal={setConfirmModalRecurr}
        showModalMsg={"How you wanted to cancel, current or all session?"}
        confirmId={sessionDataForModal}
        confirmAction={clickedItem === 2 ? cancelSession : proceedToRegister}
        noAction={() => { }}
      />
    </>
  );
}

export default WorkshopDetailComp;
